const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Registre-se, agora mesmo!",
        },
      },
      plans: {
        title: "Planos",
        registerButton: "Registrar Plano",
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "$",
        },
      },
      companies: {
        title: "Cadastrar empresa",
        form: {
          name: "Nome da empresa",
          email: "Correio eletrónico",
          phone: "Número do WhatsApp",
          plan: "Planos",
          status: "Estado",
          campaigns: "Campanhas",
          dueDate: "Data de vencimento",
          recurrence: "Recorrência",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
        table: {
          name: "Nome",
          email: "Correio eletrónico",
          phone: "Telefone",
          plan: "Planos",
          campaigns: "Campanhas",
          status: "Estado",
          createdAt: "Criada em",
          dueDate: "Vencimento",
        },
        messages: {
          loadError: "Não foi possível carregar a lista de registros",
          saveSuccess: "Operação concluída com sucesso!",
          saveError:
            "Não foi possível concluir a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos estão corretos.",
          deleteSuccess: "Operação concluída com sucesso!",
          deleteError: "Não foi possível concluir a operação",
          deleteTitle: "Eliminação de registro",
          deleteMessage: "Deseja realmente eliminar este registro?",
          registerRefreshPage:
            "Empresa registada. Atualize a página para ver as alterações.",
        },
        formTitle: {
          edit: "Editar empresa",
          registerNew: "Registar nova empresa",
        },
        sections: {
          basicInfo: "Informação básica",
          configuration: "Configuração",
        },
        loadingPlans: "A carregar planos...",
        timezone: {
          label: "Fuso horário",
          loading: "A carregar fusos horários...",
          loadingValue: "{{tz}} (a carregar...)",
          fallbackCurrent: "{{tz}} (actual)",
          hint: "Fuso horário para datas/horas em mensagens e tickets.",
          ariaLabel: "Fuso horário",
        },
        grid: {
          emptyTitle: "Não há empresas registadas",
          emptySubtitle: "Comece por registar a sua primeira empresa",
        },
        tooltips: {
          editCompany: "Editar empresa",
        },
        buttons: {
          clear: "Limpar",
          delete: "Eliminar",
          save: "Guardar",
          addDueDate: "+ Vencimento",
          user: "Utilizador",
          registerCompany: "Registar empresa",
          saving: "A guardar...",
        },
        register: {
          formTitle: "Registar nova empresa",
          companyInfoSection: "Informação da empresa",
          successTitle: "Empresa registada com sucesso!",
          loadPlansError: "Erro ao carregar os planos disponíveis",
          closingForm_one: "A fechar o formulário em {{count}} segundo...",
          closingForm_other: "A fechar o formulário em {{count}} segundos...",
          redirecting_one: "A redireccionar para o separador Empresas em {{count}} segundo...",
          redirecting_other:
            "A redireccionar para o separador Empresas em {{count}} segundos...",
          validation: {
            nameMin: "Nome demasiado curto",
            nameMax: "Nome demasiado longo",
            nameRequired: "Nome obrigatório",
            passwordMin: "Palavra-passe demasiado curta",
            passwordMax: "Palavra-passe demasiado longa",
            passwordRequired: "Palavra-passe obrigatória",
            emailInvalid: "Email inválido",
            emailRequired: "Email obrigatório",
            phoneMin: "Número de telefone demasiado curto",
            phoneRequired: "Número de WhatsApp obrigatório",
            planRequired: "Plano obrigatório",
          },
          buttons: {
            cancel: "Cancelar",
            back: "Voltar",
            registering: "A registar...",
            registered: "Registado!",
          },
        },
        values: {
          yes: "Sim",
          no: "Não",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semiannual: "Semestral",
          annual: "Anual",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
          disconnected: "WhatsApp desconectado — {{name}}",
          connected: "WhatsApp conectado — {{name}}",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
		  number: "Número",
          token: "Token",
          tokenEmpty: "Sem token (edite a conexão para definir um)",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },		
		 tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "Avaliações",
          integrations: "Integrações",
          schedules: "Horário de expediente",
		 },
        form: {
          name: "Nome",
          default: "Padrão",
          sendIdQueue: "Fila",
          timeSendQueue: "Redirecionar para fila em X minutos",
          queueRedirection: "Redirecionamento de Fila",
		  outOfHoursMessage: "Mensagem de fora de expediente",
          queueRedirectionDesc: "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          prompt: "Prompt",
          //maxUseBotQueues: "Enviar bot x vezes",
          //timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
		  greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
		  deletedAll: "Todos contatos excluídos com sucesso!",
        },
		  searchPlaceholder: "Pesquisar...",
          confirmationModal: {
          deleteTitle: "Deletar ",
          deleteAllTitle: "Deletar Todos",
          importTitle: "Importar contatos",
          exportTitle: "Exportar contatos",
          deleteMessage: "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          deleteAllMessage: "Tem certeza que deseja deletar todos os contatos? Todos os tickets relacionados serão perdidos.",
          importMessage: "Esta ação irá importar os contatos salvos na agenda do WhatsApp. Alguns modelos podem não permitir essa funcionalidade ou de acordo com sua configuração de privacidade! Verifique em até 1 hora o resultado.",
          exportMessage: "Tem certeza que deseja exportar os contatos selecionados?",
          exportAllMessage: "Tem certeza que deseja exportar todos os contatos?",
          importAgendaMessage: "Existem {count} contatos na sua agenda. Deseja importá-los?",
          titleExportAll: "Exportar todos os contatos",
          titleExportOne: "Exportar 1 contato",
          titleExportMany: "Exportar {{count}} contatos",
          titleDeleteOne: "Excluir 1 contato",
          titleDeleteMany: "Excluir {{count}} contatos",
          exportConfirmAll:
            "Tem certeza que deseja exportar todos os contatos?",
          exportConfirmMany:
            "Tem certeza que deseja exportar {{count}} contato(s)?",
          deleteSelectedMany:
            "Tem certeza que deseja excluir {{count}} contato(s)? Todos os tickets relacionados serão perdidos.",
        },
        tooltips: {
          importAgendaDisabled:
            "Esta funcionalidade está temporariamente desativada. O Baileys 6.7.21 não suporta obter contatos diretamente. Será reativada quando houver uma versão compatível do Baileys.",
        },
        buttons: {
          import: "Importar Contatos",
		  importSheet: "Import. Excel",
          add: "Adicionar Contato",
          export: "Exportar Contatos",
          delete: "Excluir Todos Contatos",
          downloadTemplate: "Baixar modelo",
        },
        table: {
          profile: "Perfil",
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          lastInteraction: "Última interação",
          status: "Status",
          actions: "Ações",
        },
        messages: {
          selectToExport: "Selecione pelo menos um contato para exportar",
          processingExport: "Processando {count} contatos...",
          exportSuccess: "Contatos exportados com sucesso",
          exportError: "Erro ao exportar contatos",
          checkingAgenda: "Verificando agenda...",
          agendaEmpty: "Nenhum contato encontrado na agenda do telefone.",
          importInvalidResponse: "Resposta inválida do servidor",
          importErrorGeneric: "Erro ao importar contatos",
          templateDownloadSuccess: "Modelo baixado com sucesso",
          templateDownloadError: "Erro ao baixar o modelo",
        },
        pagination: {
          rowsPerPage: "Registros por página:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        badge: {
          contact: "contato",
          contacts: "contatos",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",   
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
	  sideMenu: {
            name: "Menu Lateral Inicial",
            note: "Se habilitado, o menu lateral irá iniciar fechado",
            options: {
              enabled: "Aberto",
              disabled: "Fechado",
            },
          },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de tokens na resposta",
          temperature: "Temperatura",
          apikey: "Chave da API",
          max_messages: "Máximo de mensagens no histórico",
          voiceKey: "Chave da API de voz",
          voiceRegion: "Região de voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar prompt",
          edit: "Editar prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          cancelUpper: "CANCELAR",
          expand: "AMPLIAR",
          saveChanges: "Salvar alterações",
        },
        sections: {
          provider: "Configuração do provedor de IA",
          api: "Configuração da API",
          basic: "Informações básicas",
          advanced: "Configurações avançadas",
          media: "Arquivos multimídia",
          workMode: "Modo de trabalho",
        },
        providerInfo: {
          title: "Configuração do provedor de IA",
          body1:
            "Selecione o provedor de inteligência artificial que este prompt usará. Cada um oferece modelos e recursos diferentes conforme sua necessidade.",
          body2:
            "Provedores disponíveis: OpenAI oficial, Google Gemini (AI Studio), Anthropic Claude, DeepSeek, Kimi e OpenRouter. Cada opção exige a chave de API desse provedor (OpenRouter usa sk-or-v1-…).",
        },
        mustValidateBeforeSave:
          "Valide a chave da API e o provedor antes de salvar. Use o botão «Testar conexão».",
        mustValidateBeforeSaveWithStored:
          "Se alterou o provedor ou colou uma chave nova, use «Testar conexão». Para só editar o texto/opções, deixe a chave em branco e mantenha o mesmo provedor.",
        validation: {
          nameRequired: "O nome é obrigatório",
          apiKeyRequired: "A chave da API é obrigatória",
          promptRequired: "O prompt é obrigatório",
          maxTokensRequired: "O máximo de tokens é obrigatório",
          temperatureRequired: "A temperatura é obrigatória",
          maxMessagesRequired: "O máximo de mensagens é obrigatório",
        },
        fields: {
          aiProvider: "Provedor de IA",
          promptName: "Nome do prompt",
          promptNameHelper: "Ex.: bot de suporte, assistente de vendas…",
          promptNamePlaceholder: "Ex.: bot de suporte",
          mainPrompt: "Prompt principal",
          mainPromptHelper: "Defina como a IA deve se comportar. Seja específico e claro.",
          mainPromptPlaceholder:
            "Você é um assistente de suporte técnico. Responda de forma profissional e útil…",
          charCount: "Quantidade de caracteres: {{count}}",
          temperature: "Temperatura",
          temperatureHelper: "0.0 = determinístico, 2.0 = muito criativo",
          maxTokens: "Máximo de tokens",
          maxTokensHelper: "Limite de tokens na resposta",
          maxMessages: "Máximo de mensagens",
          maxMessagesHelper: "Mensagens mantidas no contexto",
          queueOptional: "Departamentos (opcional)",
          noQueue: "Sem departamento",
          workModeLabel: "Modo de trabalho",
          workModeLayers: "Camadas contextuais",
          workModePdfs: "Documentos PDF",
          workModeHintLayers: "Usa camadas contextuais ativadas por palavras-chave",
          workModeHintPdfs: "Envie PDFs para a IA aprender com eles",
        },
        apiTest: {
          validating: "Validando…",
          validated: "✅ Validado",
          validatedHelper: "✅ Chave da API validada",
          storedKeyMaskPlaceholder:
            "Cole aqui apenas para trocar a chave (ao editar, a chave salva já aparece).",
          storedKeyHelper:
            "Ao editar este prompt você vê a chave da API armazenada no servidor. Deixe igual para mantê-la ou substitua para atualizar. Use «Testar conexão» para validar.",
          testConnection: "Testar conexão",
          enterApiKeyFirst: "Informe uma chave da API primeiro",
          selectProviderFirst: "Selecione um provedor primeiro",
          keyTooShortToast:
            "A chave da API parece muito curta. Verifique se está correta.",
          keyTooShort: "Chave da API muito curta",
          connectionSuccess: "Conexão bem-sucedida",
          validationFailed: "Falha na validação",
          validateError: "Erro ao validar a API",
          unknownError: "Erro desconhecido",
        },
        media: {
          savePromptFirst: "Primeiro salve o prompt",
          savePromptFirstToast: "Primeiro salve o prompt",
          unknownFileType: "Erro: tipo de arquivo não reconhecido",
          noFilesSelected: "Nenhum arquivo selecionado",
          unexpectedError: "Erro inesperado: {{message}}",
          fileDeleted: "Arquivo excluído com sucesso",
          deleteFileError: "Erro ao excluir arquivo: {{message}}",
          maxSixFiles: "Máximo de 6 arquivos por prompt",
          urlAdded: "URL externa adicionada com sucesso",
          urlAddError: "Erro ao adicionar URL: {{message}}",
          addUrl: "Adicionar URL",
          uploadFile: "Enviar arquivo",
          hintFiles:
            "📎 Você pode adicionar até 6 arquivos multimídia (imagens, vídeo, áudio, documentos)",
          hintLimits:
            "📏 Limites: imagens/áudio 10 MB, vídeo/documentos 15 MB",
          hintSyntax:
            "💡 Use [MEDIA: nomearquivo.ext] no prompt para referenciar arquivos",
          filesCount: "{{current}}/6 arquivos adicionados",
          uploadSuccessCount: "{{count}} arquivo(s) adicionado(s) com sucesso",
          maxSixWithCounts:
            "Máximo de 6 arquivos por prompt. Você já tem {{current}} e está adicionando {{adding}}. Só pode adicionar mais {{remaining}}.",
          maxSixNoMore:
            "Máximo de 6 arquivos por prompt. Você já tem {{count}} arquivos. Não é possível adicionar mais.",
          someRejected: "Alguns arquivos não puderam ser adicionados: {{list}}",
          fileTooBig: "{{name}}: excede {{maxMb}} MB",
          uploadPartial:
            "{{uploaded}} arquivo(s) adicionado(s), {{failed}} falharam: {{names}}",
          uploadFailedDetail: "Erro ao enviar arquivos: {{details}}",
          uploadNone:
            "Não foi possível enviar nenhum arquivo. Verifique o console para detalhes.",
        },
        urlDialog: {
          title: "Adicionar URL externa",
          urlLabel: "URL do arquivo",
          urlPlaceholder: "https://exemplo.com/arquivo.jpg",
          captionLabel: "Descrição (opcional)",
          captionPlaceholder: "Descrição do arquivo",
          hintPublic: "💡 Garanta que a URL seja acessível publicamente",
          add: "Adicionar",
          close: "Fechar",
        },
        expanded: {
          confirmClose: "Deseja salvar as alterações antes de fechar?",
          title: "Editor ampliado — prompt principal",
          unsavedChip: "Alterações não salvas",
          intro:
            "Edite seu prompt com mais espaço. Referências multimídia [MEDIA: nomearquivo.ext] aparecem destacadas na pré-visualização.",
          editorPlaceholder: "Escreva seu prompt aqui…",
          charCount: "Quantidade de caracteres: {{count}}",
          previewTitle: "Pré-visualização (destacada):",
          toastSaved: "Prompt atualizado com sucesso",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo de tokens (resposta)",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteTitleNamed: "Excluir o prompt «{{name}}»?",
          deleteMessage:
            "Tem certeza? Esta ação não pode ser desfeita!",
        },
        buttons: {
          add: "Adicionar prompt",
        },
        listPage: {
          title: "Prompts de IA",
          addButton: "Adicionar prompt",
          providersTitle: "Provedores de IA disponíveis",
          providersIntro:
            "Escolha o provedor que melhor atende às suas necessidades. Temos provedores oficiais: OpenAI, Gemini, Grok, Deepseek® e OpenRouter.",
          providersApiKey:
            "Cada um oferece modelos e recursos diferentes. Certifique-se de ter uma chave de API válida para o provedor selecionado.",
          tablePromptName: "Nome do prompt",
          tableProvider: "Provedor de IA",
          tableMaxTokens: "Máximo de tokens",
          tableTemperature: "Temperatura",
          tableMaxMessages: "Máximo de mensagens",
          tableActions: "Ações",
          tokensChip: "{{count}} tokens",
          tooltipEdit: "Editar prompt",
          tooltipDelete: "Excluir prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          whatsapp: "Conexão Origem: "
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar departamento",
          edit: "Editar departamento",
        },
		confirmationModal: {
		  "deleteTitle": "Excluir",
		},
        tabs: {
          queueData: "Dados do departamento",
          serviceHours: "Horário de serviço",
        },
        automation: {
          title: "Automação de processos",
          intro:
            "Você pode automatizar conversas com prompts personalizados, fluxos (FlowBuilder), integrações externas ou um chatbot com menus de opções: o contato escolhe com botões no chat, não em texto livre. Apenas uma das quatro opções pode estar ativa por vez; nenhuma é obrigatória.",
        },
        form: {
          name: "Nome",
          departmentName: "Nome do departamento",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
          enableGreeting: "Ativar saudação",
          greetingEnabledOn: "Habilitado — a mensagem de boas-vindas será enviada.",
          greetingEnabledOff: "Desativado — nenhuma saudação é exibida ou enviada.",
          greetingRequired: "Se a saudação estiver ativa, preencha a mensagem.",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          ratingMessage: "Mensagem de avaliação",
          token: "Token",
          orderQueue: "Ordem da fila (Bot)",
          integrationId: "Integração",
          noIntegration: "Sem integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
		  attach: "Anexar Arquivo",
        },
      },
      userModal: {
        tabs: {
          user: "Usuário",
          extra: "Adicional"
        },
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          superAdmin: "Superadministrador",
          queuesFromTeam: "Os departamentos vêm da equipe. Os individuais são mantidos caso o modo equipes seja desligado.",
          whatsappHint: "Conexão usada para os tickets que este usuário criar manualmente. Vazio = a padrão da empresa.",
                    superAdminHint: "Seu papel é concedido na instalação e não se altera aqui.",
          roleUnavailable: "Papel não disponível nesta empresa",
          whatsapp: "Conexão Padrão",
          language: "Idioma do painel",

          allTicket: "Ticket Sem Fila [Invisível]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Desabilitado",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          cancelMeeting: "Cancelar reunião",
          exit: "Sair",
        },
        selectConnectionPlaceholder: "Selecione uma conexão",
        bodyCharCounter: "{{current}}/500 caracteres",
        success: "Agendamento salvo com sucesso.",
        toasts: {
          deleted: "Arquivo excluído com sucesso.",
          meetingCancelled: "Reunião cancelada com sucesso",
          updated: "✅ Agendamento atualizado com sucesso",
          created: "✅ Agendamento criado com sucesso",
          noDataSave: "❌ Erro: não há dados para salvar",
        },
        confirmationModal: {
          deleteTitle: "Excluir arquivo",
          deleteMessage: "Deseja excluir este arquivo?",
        },
        cancelMeetingTitle: "Cancelar reunião",
        cancelMeetingMessage:
          "Tem certeza de cancelar esta reunião? Será enviada mensagem de cancelamento ao contato.",
        confirmScheduleTitle: "Confirmar agendamento?",
        confirmScheduleDate: "Data e hora:",
        confirmScheduleContact: "Contato:",
        confirmScheduleWhatsapp: "Conexão:",
        confirmScheduleMessage: "Mensagem:",
        confirmScheduleQuestion:
          "Confirma o agendamento com os dados exibidos?",
        validationErrorTitle: "❌ Erro de validação",
        understood: "Entendi",
        validationGeneric: "Erro ao validar o agendamento",
        contactNotFound: "Contato não encontrado",
        whatsappNotFound: "Conexão não encontrada",
        dialogStatusErro: "Erro de envio",
        dialogStatusPrefix: "Mensagem",
        autocompleteNoContacts: "Nenhum contato encontrado",
        searchContactLabel: "Digite para buscar contatos",
        searchContactPlaceholder: "Clique para ver contatos disponíveis",
        attachFile: "Anexar arquivo",
        validation: {
          required: "Obrigatório",
          invalidDateTime: "❌ Data/hora inválida",
          pastDateTime:
            "❌ Não é possível agendar no passado. Hora atual: {{now}}",
          minTenMinutes:
            "❌ Antecedência mínima de 10 minutos. Mais cedo permitido: {{min}}",
          maxOneYear: "❌ Não é possível agendar mais de 1 ano à frente",
          febMaxDays: "❌ Fevereiro não pode ter mais de 29 dias",
          feb29Leap: "❌ 29 de fevereiro só em anos bissextos",
          month30: "❌ O mês {{month}} não pode ter mais de 30 dias",
          bodyShort: "Mensagem muito curta",
          messageMax: "❌ A mensagem não pode exceder 500 caracteres",
          messageMinChars: "❌ A mensagem deve ter pelo menos 3 caracteres",
          messageMinValid:
            "❌ A mensagem deve ter pelo menos 2 caracteres válidos",
          allFieldsRequired:
            "❌ Todos os campos são obrigatórios: contato, conexão, mensagem e data/hora",
        },
        connectionFallback: "Conexão {{id}}",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
        },
        form: {
          name: "Nome",
          color: "Cor",
          namePlaceholder: "Ex.: Atendimento, Cliente, Interessado…",
          pickColorTitle: "Selecionar cor",
          kanbanLabel: "Usar no Kanban",
          kanbanHint:
            "Tags com Kanban ativo aparecem como colunas no quadro",
        },
        validation: {
          nameMin: "Nome muito curto",
          required: "Obrigatório",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
      },
      schedulePage: {
        moduleTitle: "Módulo da agenda",
        scheduledTotal: "{{count}} agendamentos",
        title: "Agendamentos ({{count}})",
        notAvailable: "N/D",
        viewTable: "Vista em tabela",
        viewCalendar: "Vista em calendário",
        newButton: "Novo agendamento",
        table: {
          date: "Data",
          time: "Hora",
          contact: "Contato",
          connection: "Conexão",
          message: "Mensagem",
          status: "Status",
          actions: "Ações",
        },
        status: {
          error: "Erro",
          cancelled: "Cancelado",
          sent: "Enviado",
          overdue: "Vencido",
          pending: "Pendente",
        },
        cancelMeetingTitle: "Cancelar reunião?",
        cancelScheduleTitle: "Cancelar agendamento?",
        cancelMeetingMessage:
          "Cancelar esta reunião? Todos os lembretes associados serão removidos.",
        cancelScheduleMessage:
          "Cancelar este agendamento? Será enviada mensagem de cancelamento ao contato.",
        toastMeetingCancelled: "Reunião cancelada com sucesso",
        toastScheduleCancelled: "Agendamento cancelado com sucesso",
        deleteTitleAlreadyCancelled: "Já cancelado",
        deleteTitleCancel: "Cancelar agendamento",
        calendar: {
          date: "Data",
          time: "Hora",
          event: "Evento",
          allDay: "Dia inteiro",
          week: "Semana",
          work_week: "Agendamentos",
          day: "Dia",
          month: "Mês",
          previous: "Anterior",
          next: "Próximo",
          yesterday: "Ontem",
          tomorrow: "Amanhã",
          today: "Hoje",
          agenda: "Agenda",
          noEventsInRange: "Não há agendamentos neste período.",
          showMore: "+{{total}} mais",
        },
      },
      appointmentsModule: {
        page: {
          moduleTitle: "Módulo da agenda",
          newAppointment: "Nova consulta",
          tabs: {
            dashboard: "Dashboard",
            calendar: "Calendário",
            history: "Histórico",
            webLeads: "Solicitações web",
            settings: "Configuração",
          },
          accessDeniedTitle: "Sem acesso ao módulo Agenda",
          accessDeniedP1:
            "É preciso estar vinculado como profissional/instrutor em Agenda > Configuração > Equipe, ou ser administrador.",
          accessDeniedP2:
            "Fluxo: cadastre o usuário → depois vincule como Profissional na Equipe.",
          goHome: "Ir ao início",
          checkingAccess: "Verificando acesso…",
        },
        status: {
          all: "Todos",
          pending: "Pendente",
          confirmed: "Confirmada",
          rescheduled: "Reagendada",
          in_progress: "Em andamento",
          completed: "Concluída",
          no_show: "Não compareceu",
          cancelled: "Cancelada",
        },
        webLeads: {
          loading: "Carregando solicitações…",
          empty: "Ainda não chegou nenhuma solicitação pelo site",
          emptyHint:
            "Assim que alguém enviar o formulário da página, aparecerá aqui sem precisar recarregar.",
          countLine: "{{count}} solicitações · {{pending}} sem revisar",
          autoRefreshHint: "Atualiza sozinho a cada 10 segundos.",
          reload: "Recarregar",
          filterAll: "Todas",
          statusNueva: "Nova",
          statusVista: "Vista",
          statusDescartada: "Descartada",
          justNow: "Há alguns segundos",
          minutesAgo: "Há {{count}} min",
          colReceived: "Recebida",
          colName: "Nome",
          colPhone: "WhatsApp",
          colPreferred: "Data preferida",
          colService: "Serviço",
          colSource: "Origem",
          colStatus: "Estado",
          colActions: "Ações",
          tableAria: "Solicitações recebidas pelo site",
          markSeen: "Marcar como vista",
          discard: "Descartar",
          seePayload: "Ver dados recebidos",
          payloadTitle: "Dados recebidos do formulário",
          payloadHint: "Corpo original tal como chegou, sem modificações.",
          close: "Fechar",
        },
        calendar: {
          date: "Data",
          time: "Hora",
          event: "Evento",
          today: "Hoje",
          previous: "Anterior",
          next: "Próximo",
          month: "Mês",
          week: "Semana",
          day: "Dia",
          agenda: "Agenda",
          noEventsInRange: "Não há consultas neste período.",
          noName: "Sem nome",
          serviceFallback: "Serviço",
        },
        dashboard: {
          wd0: "Seg",
          wd1: "Ter",
          wd2: "Qua",
          wd3: "Qui",
          wd4: "Sex",
          wd5: "Sáb",
          wd6: "Dom",
          kpiWeek: "Sessões esta semana",
          kpiPending: "Pendentes de confirmação",
          kpiToday: "Sessões hoje",
          kpiRate: "Taxa de comparecimento (30 dias)",
          chartTitle: "Sessões por dia — {{month}}",
          todayTitle: "Sessões de hoje",
          todayEmpty: "Não há sessões agendadas para hoje",
          todayLine: "{{time}}: {{contact}} — {{service}}",
          professionalPrefix: "Profissional:",
          upcomingTitle: "Próximas sessões",
          upcomingEmpty: "Não há sessões nos próximos 30 dias",
          chartConfirmed: "Confirmadas",
          chartPending: "Pendentes",
          chartCancelled: "Canceladas",
        },
        historial: {
          loading: "Carregando histórico…",
          empty: "Não há consultas com os filtros aplicados",
          emptyHint:
            "Ajuste as datas ou o estado no cabeçalho para ver mais resultados",
          countOrder: "{{count}} consultas · Ordem: {{order}}",
          orderAsc: "próximas primeiro",
          orderDesc: "mais recentes primeiro",
          changeOrder: "Alterar ordem",
          edit: "Editar",
          editReschedule: "Editar / Reagendar",
          editAria: "Editar consulta",
          tableAria: "Histórico de consultas",
          colDate: "Data",
          colTime: "Hora",
          colContact: "Contato",
          colService: "Serviço",
          colProfessional: "Profissional",
          colStatus: "Estado",
          colActions: "Ações",
          rowsPerPage: "Linhas por página:",
          rowsPerPageShort: "Linhas:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        config: {
          firstTimeTitle: "Primeira vez configurando a Agenda?",
          firstTimeSubtitle:
            "Configure perfil, serviços, equipe e horários em poucos passos.",
          firstTimeCta: "Comece aqui",
          activeProfileTitle: "Perfil ativo: {{name}}",
          activeProfileSubtitle:
            "Altere qualquer parte da configuração inicial.",
          cardPerfilTitle: "Tipo de negócio / perfil",
          cardPerfilDesc:
            "Defina se é Beleza, Comercial, Saúde, Educação ou Técnico. Afeta textos e colunas Kanban.",
          cardServiciosTitle: "Serviços / programas",
          cardServiciosDesc:
            "Catálogo de serviços, disciplinas ou programas com duração e preço.",
          cardEquipoTitle: "Equipe de instrutores",
          cardEquipoDesc:
            "Profissionais que atendem. Vincule cada um a um usuário para acessar a Agenda e confirmar consultas.",
          cardHorariosTitle: "Horário de atendimento",
          cardHorariosDesc: "Dias, horários e duração dos slots por dia.",
          cardSecuenciasTitle: "Sequências automáticas do Agente IA",
          cardSecuenciasDesc:
            "Quando e como o Agente IA captura dados e dispara fluxos (pedido de consulta). O tom é configurado em Prompts IA.",
          equipoIntro:
            "Vincule cada profissional a um usuário (em Usuários) para entrar na Agenda e confirmar consultas.",
          equipoConfigureBtn:
            "Configurar equipe (nomes, funções e especialidades)",
          loadingProfessionals: "Carregando profissionais…",
          tableProfessional: "Profissional",
          tableRole: "Função / especialidade",
          tableLinkUser: "Vincular a usuário",
          noneUser: "— Nenhum —",
          noProfessionals:
            "Não há profissionais. Use o botão acima para adicionar a equipe na configuração inicial.",
          secuenciasIntro:
            "Escolha qual Agente IA (Prompt) captura pedidos de consulta no chat. Tom e personalidade ficam nesse agente.",
          loading: "Carregando…",
          kanbanHint:
            "Se mudou o tipo de negócio, recrie as colunas Kanban do perfil atual.",
          kanbanRecreate: "Recriar colunas Kanban",
          kanbanProcessing: "Processando…",
          edit: "Editar",
          editSectionAria: "Editar {{section}}",
          businessDialogTitle: "Dados do negócio",
          businessDialogDesc:
            "Edite o nome, o perfil, o fuso horário e a moeda. Seus serviços, equipe, horários e agendamentos não são alterados.",
          businessDialogName: "Nome do negócio",
          businessDialogProfile: "Perfil do negócio",
          businessDialogProfileHelper:
            "Se mudar o perfil, use «Recriar colunas Kanban» para atualizar o quadro.",
          businessDialogTimezone: "Fuso horário",
          businessDialogCurrency: "Moeda",
          businessDialogCancel: "Cancelar",
          businessDialogSave: "Salvar alterações",
          businessDialogSaving: "Salvando…",
          businessDialogSaved: "Dados do negócio atualizados.",
          toastLinkOk:
            "Vínculo atualizado. O instrutor pode acessar a Agenda com seu usuário.",
          toastKanbanOk: "Colunas Kanban recriadas conforme o perfil.",
          errorProfileFirst:
            "Configure primeiro o perfil na configuração inicial.",
        },
        appointmentModal: {
          titleNew: "Nova consulta",
          notifyContact: "Avisar o paciente agora",
          notifyContactOn: "O modelo de confirmação será enviado por WhatsApp ao salvar.",
          notifyContactOff: "A consulta será criada confirmada, mas sem aviso imediato.",
          titleEdit: "Consulta {{code}}",
          contactFallback: "Contato #{{id}}",
          client: "Cliente:",
          service: "Serviço:",
          professional: "Profissional:",
          date: "Data:",
          statusLabel: "Estado",
          viewProfile360: "Ver perfil 360",
          rescheduleHint:
            "Informe nova data, serviço e profissional para reagendar. Será enviada notificação ao contato.",
          newDateTime: "Nova data e hora *",
          duration: "Duração (minutos)",
          notes: "Notas",
          introNew:
            "Registre manualmente uma nova consulta. Digite para buscar e escolha na lista filtrada.",
          contactLabel: "Contato *",
          contactPlaceholder: "Digite nome ou número para buscar...",
          contactHelper: "Obrigatório. Busque por nome ou telefone.",
          noOptionsShort: "Digite pelo menos 2 caracteres para buscar",
          noOptionsEmpty: "Sem resultados",
          connectionLabel: "Conexão *",
          connectionPlaceholder:
            "Selecione a linha WhatsApp (conexão) desta consulta",
          connectionHelper:
            "Obrigatório. Indica sob qual conexão a consulta fica registrada (mesma lógica do lembrete agendado).",
          connectionNamed: "Conexão {{id}}",
          dash: "—",
          serviceField: "Serviço",
          serviceSearchPh: "Buscar serviço...",
          serviceHelper: "Opcional. Catálogo de serviços.",
          noServices: "Sem serviços configurados",
          professionalField: "Profissional",
          professionalSearchPh: "Buscar profissional...",
          professionalHelper: "Opcional. Equipe de instrutores.",
          noProfessionalsConfigured: "Sem profissionais configurados",
          datetimeLabel: "Data e hora *",
          datetimeHelper: "Obrigatório. Momento da consulta.",
          durationHelper: "Padrão 60 minutos.",
          notesPlaceholder: "Observações adicionais...",
          cancel: "Cancelar",
          saveReschedule: "SALVAR E REAGENDAR",
          saveStatus: "Salvar estado",
          create: "Criar consulta",
          toastContactDateRequired: "Contato e data são obrigatórios",
          toastWhatsappRequired:
            "Selecione a conexão (WhatsApp) da consulta",
          toastStatusUpdated: "Estado atualizado",
          toastCreated: "Consulta criada",
          toastRescheduleDateRequired:
            "A nova data é obrigatória para reagendar",
          toastRescheduled:
            "Consulta reagendada. Notificação enviada ao contato.",
        },
      },
      toDoList: {
        title: "Anotações do operador",
        searchPlaceholder: "Buscar tarefas…",
        stats: {
          total: "Total",
          pending: "Pendentes",
          completed: "Concluídas",
          urgent: "Urgentes",
        },
        form: {
          newTask: "Nova tarefa",
          editTask: "Editar tarefa",
          descriptionLabel: "Descrição da tarefa",
          descriptionPlaceholder: "Ex.: Revisar configuração do servidor…",
          priority: "Prioridade",
          category: "Categoria",
          add: "Adicionar tarefa",
          save: "Salvar alterações",
          cancel: "Cancelar",
        },
        priority: { low: "Baixa", medium: "Média", high: "Alta" },
        categories: {
          general: "Geral",
          urgent: "Urgente",
          followup: "Acompanhamento",
          meeting: "Reunião",
          system: "Sistema",
          customer: "Cliente",
        },
        filters: { title: "Filtros", all: "Todas", allStatus: "Todos", status: "Estado" },
        statusLabel: { pending: "Pendente", completed: "Concluída" },
        empty: {
          none: "Nenhuma tarefa criada",
          noneHint: "Crie sua primeira tarefa no formulário acima",
          filtered: "Nenhuma tarefa com os filtros aplicados",
          filteredHint: "Ajuste os filtros para ver mais tarefas",
        },
        tooltips: {
          markPending: "Marcar como pendente",
          markDone: "Marcar como concluída",
          edit: "Editar tarefa",
          delete: "Excluir tarefa",
        },
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO",
          titleFileList: "Lista de arquivo(s)"
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
          closeallTicket: "Fechar"
        },
        confirmation: {
          title: "⚠️ Confirmação de fechamento de tickets",
          subtitle: "Esta ação fechará TODOS os tickets abertos de forma permanente",
          warning: "Esta ação não pode ser desfeita",
          whichTicketsQuestion: "Quais tickets deseja fechar?",
          noTicketsForOption:
            "Não há tickets para fechar conforme a opção selecionada",
          warningEmojiAria: "Aviso",
          optionAttendingOpen: "EM ATENDIMENTO (Abertos)",
          optionPending: "PENDENTE",
          optionBoth: "AMBOS (EM ATENDIMENTO + PENDENTE)",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        accessDenied: "Você não tem acesso a este ticket",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
          filterConnections: "Filtro por conexões",
          filterContacts: "Filtro por contato",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          ticketsPerPage: "Tickets por página",
          searchMessagesTooltip:
            "Buscar também no conteúdo das mensagens (mais lento)",
        },
        buttons: {
          showAll: "Todos",
        },
        managerTabs: {
          tooltips: {
            newTicket: "Criar novo ticket",
            resolveTickets: "Resolver tickets",
            showOpen: "Mostrar tickets abertos",
            showClosed: "Mostrar tickets fechados",
            filterByQueues: "Filtrar por filas",
            filterByTags: "Filtrar por etiquetas",
            activeFilters: "Ver filtros ativos",
          },
          emptyQueues: "Não há filas disponíveis",
          emptyTags: "Não há etiquetas disponíveis",
          tabs: {
            groups: "GRUPOS",
            aiAgents: "AGENTES IA",
          },
        },
        filterPanel: {
          title: "Filtros",
          show: "Mostrar",
          hide: "Ocultar",
          departments: "Filas",
          tags: "Etiquetas",
          departmentsWithCount: "Filas ({{count}})",
          tagsWithCount: "Etiquetas ({{count}})",
          clearFilters: "Limpar filtros",
          emptyState:
            "Não há filtros ativos. Selecione filas ou etiquetas acima.",
        },
        welcome: {
          title: "Bem-vindo ao seu módulo de chat",
          subtitle:
            "Você pode abrir um novo chat ou aguardar ser atribuído a você",
        },
        aria: {
          resizeTicketsPanel: "Redimensionar painel de tickets",
        },
        mobile: {
          bottomNav: {
            chat: "Chat",
            tickets: "Atendimentos",
          },
        },
        searchResults: {
          searchAria: "Pesquisa",
          searching: "Buscando...",
          resultsFor: 'Resultados para "{{term}}"',
          noResults: "Nenhum resultado encontrado",
          emptySection: "Não há resultados nesta seção.",
          total: "{{count}} no total",
          sections: {
            open: "EM ATENDIMENTO",
            pending: "PENDENTE",
            closed: "FECHADOS",
          },
        },
      },
      transferTicketModal: {
        sinDestino: "Escolha um departamento ou uma pessoa: o ticket não pode ficar sem destino.",
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        allHeader: "Todos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        buttons: {
          accept: "Aceitar",
          closed: "Finalizar",
		  transfer: "Transferir",
          reopen: "Reabrir"
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      myTeam: {
        title: "Minha equipe",
        activity: "Atividade da equipe",
        online: "Online",
        offline: "Desconectado",
        subtitle: "Sua empresa, as equipes às quais você pertence e quem as supervisiona.",
        supervisor: "Supervisor",
        noSupervisor: "Esta equipe ainda não tem supervisor designado.",
        departments: "Departamentos atendidos",
        noDepartments: "Esta equipe não tem departamentos atribuídos.",
        members: "Membros",
        youSupervise: "Você supervisiona esta equipe",
        you: "você",
        inheritsRole: "Herda seu papel",
        noTeams: "Você não pertence a nenhuma equipe. Trabalha com o escopo do seu papel.",
        table: {
          name: "Nome",
          role: "Papel nesta equipe",
          state: "Status",
          handling: "Atendendo",
          closedToday: "Fechados hoje"
        }
      },
      userTeams: {
        label: "Equipe à qual pertence",
        labelOne: "Equipe que supervisiona",
isSupervisor: "Já é supervisor desta equipe.",
                willSupervise: "Será supervisor de {{team}}.",
supervisedByLabel: "supervisiona",
        noSupervisor: "sem supervisor",
        required: "Deve pertencer a uma equipe.",
        noneFree: "Não há equipes livres: todas têm supervisor",
        empty: "Ainda não há equipes criadas"
      },
      roleMatrix: {
        modules: {
          agenda: "Agenda",
          announcements: "Anúncios",
          api: "API",
          campaigns: "Campanhas",
          chats: "Chat interno",
          connections: "Conexões",
          contacts: "Contatos",
          files: "Lista de arquivos",
          financial: "Faturamento",
          flowbuilder: "FlowBuilder",
          groups: "Grupos de WhatsApp",
          kanban: "Kanban",
          prompts: "Agentes IA",
          queues: "Departamentos",
          quickmessages: "Respostas rápidas",
          reports: "Relatórios",
          roles: "Funções e permissões",
          schedules: "Agendamentos",
          settings: "Configurações",
          tags: "Etiquetas",
          tickets: "Tickets",
          "user-groups": "Subgrupos",
          users: "Usuários"
        },
        page: {
          title: "Funções e permissões",
          subtitle: "Defina o que cada função pode fazer em cada módulo (ver / criar / editar / excluir…).",
          newRole: "Nova função",
          colCode: "Código",
          colName: "Nome",
          colScope: "Âmbito",
          colPerms: "Permissões",
          colUsers: "Usuários",
          colActions: "Ações",
          systemTooltip: "Função do sistema: ao editá-la será criada uma cópia da sua empresa",
          duplicate: "Duplicar",
          duplicated: "Função duplicada",
          deleted: "Função excluída",
          confirmDeleteTitle: "Excluir a função {{name}}?",
          confirmDeleteBody: "Os usuários com esta função devem ser reatribuídos antes de excluí-la.",
          duplicateTitle: "Duplicar função: {{name}}",
          duplicateHint: "Será criada uma nova função editável com as {{total}} permissões da original. A função de origem não é modificada.",
          copyCodeSuffix: "_COPIA",
          copyNameSuffix: " (cópia)"
        },
        scopes: {
          empresa: "Empresa",
          equipo: "Equipe",
          personal: "Pessoal",
          plataforma: "Plataforma"
        },
        modal: {
          new: "Nova função",
          edit: "Editar função: {{name}}",
          subtitle: "Marque o que esta função pode fazer em cada módulo.",
          superadminNotice: "A função SUPERADMIN não pode ser modificada: é a única que poderia deixar o sistema sem ninguém capaz de restaurar permissões.",
          copyNotice: "Esta função é compartilhada por todas as empresas. Ao salvar, será criada uma versão própria da sua empresa com suas alterações; as demais não serão afetadas.",
code: "Código",
          name: "Nome",
                    frozenTooltip: "Você não pode modificar uma permissão que não possui",
          saved: "Matriz atualizada",
          sessionsNotice: "{{total}} usuário(s) deverão renovar a sessão para ver a alteração",
          selectedCount: "{{total}} permissão(ões) selecionada(s)",
          save: "Salvar",
          cancel: "Cancelar"
        },
        bulk: {
          all: "Marcar tudo",
          allClear: "Desmarcar tudo",
          column: "Marcar toda a coluna",
          columnClear: "Desmarcar toda a coluna",
          row: "Marcar toda a linha",
          rowClear: "Desmarcar toda a linha"
        },
        columns: {
          module: "Módulo"
        },
        actions: {
          ver: "Ver",
          crear: "Criar",
          editar: "Editar",
          eliminar: "Excluir",
          aprobar: "Aprovar",
          procesar: "Processar",
          administrar: "Administrar"
        }
      },
      mainDrawer: {
        groups: {
          whatsapp: "Chats",
          dashboard: "Dashboard",
          gruposWA: "Grupos de WA",
          mensajes: "Mensagens",
          configuracion: "Configuração",
          administracion: "Administração",
          flowbuilder: "FlowBuilder",
          utilidades: "Utilitários",
        },
        listItems: {
          dashboard: "Dashboard",
          metrics: "Métricas",
          connections: "Conexões",
          wabaTemplates: "Modelos Meta",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          kanban: "Kanban",
          todolist: "Anotações",
          contacts: "Contatos",
          groupsWA: "Lista de grupos WA",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          users: "Usuários",
          userRoles: "Papel do usuário",
          rolesPermissions: "Funções e permissões",
          userGroups: "Subgrupos",
          myTeam: "Minha equipe",
          settings: "Configurações",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          campaignsDispatch: "Envio de mensagens",
          metaCampaigns: "Campanhas Meta",
          scheduledMessages: "Individual",
          contactLists: "Lista de contatos",
          campaignShippingReports: "Relatório de envio",
          broadcastTemplates: "Modelos de Difusão",
          annoucements: "Informativos",
          chats: "Chat interno",
          localChat: "Chat local",
          financeiro: "Financeiro",
          subscription: "Assinatura",
          files: "Lista de arquivos",
          prompts: "Agentes IA",
          queueIntegration: "Integrações",
          flowbuilders: "Lista de fluxos",
          flowcampaigns: "Campanhas de fluxo",
          dashboardWhatsApp: "WhatsApp",
          vpsPerformance: "Desempenho VPS",
          groupCampaigns: "Campanhas de grupos",
          reports: "Relatórios",
        },
        appBar: {
          notRegister: "Sem notificações",
          user: {
            profile: "Perfil",
            logout: "Sair",
            label: "Usuário:",
          },
          tooltips: {
            openDrawer: "Abrir menu",
            closeDrawer: "Fechar menu",
            navigationMenu: "Menu de navegação",
            openNavigationMenu: "Abrir menu de navegação",
            internalChat: "Chat interno",
            help: "Ajuda",
            announcements: "Anúncios",
            whatsappNotifications: "Notificações do WhatsApp",
            settings: "Configurações",
            updateVersion: "Atualizar versão",
            logout: "Sair",
          },
          settingsMenu: {
            lightMode: "Modo claro",
            darkMode: "Modo escuro",
            logs: "Logs",
          },
          versionLong: "VERSÃO {{version}}",
          versionShort: "V{{version}}",
        },
      },
      flowbuilders: {
        title: "Fluxos Automatizados",
        searchPlaceholder: "Buscar fluxos...",
        noFlows: "Nenhum fluxo criado",
        rowsPerPage: "Linhas por página",
        buttons: {
          add: "Novo Fluxo",
        },
        table: {
          name: "Nome",
          status: "Status",
          createdAt: "Criado em",
          actions: "Ações",
        },
        status: {
          active: "Ativo",
          inactive: "Inativo",
        },
        actions: {
          edit: "Editar",
          delete: "Excluir",
        },
        confirmationModal: {
          deleteTitle: "Excluir Fluxo",
          deleteMessage:
            "Tem certeza de que deseja excluir este fluxo? Esta ação não pode ser desfeita.",
        },
        toasts: {
          deleted: "Fluxo excluído com sucesso",
          created: "Fluxo criado com sucesso",
          updated: "Fluxo atualizado com sucesso",
          saved: "Fluxo salvo com sucesso",
          saveSuccess: "Fluxo salvo com sucesso",
          saveError: "Erro ao salvar o fluxo",
        },
        loading: "Carregando fluxo...",
        editor: {
          nodesPanel: "Nós Disponíveis",
          newFlow: "Novo Fluxo",
          saving: "Salvando",
          save: "Salvar",
          cancel: "Cancelar",
          canvas: "Canvas do Fluxo",
          noNodes:
            "Não há nós no fluxo. Clique em um nó do painel lateral para adicioná-lo.",
          connecting: "Conectando... (Clique em outro nó)",
          connectionHint:
            "Shift + Clique em um nó para iniciar a conexão, depois clique em outro nó para conectar",
          nodesHint: "Clique em um nó para adicioná-lo ao canvas",
          shortcuts: "Atalhos de teclado",
          shortcutDrag: "Arrastar: Clique e arraste para mover",
          shortcutConnect:
            "Conectar: Shift + Clique no nó de origem, depois clique no nó de destino",
          shortcutConfig: "Configurar: Clique no nó ou duplo clique",
        },
        modals: {
          title: "Configurar {nodeType}",
          cancel: "Cancelar",
          save: "Salvar",
          noConfig: "Este nó não requer configuração",
          message: {
            text: "Texto da mensagem",
          },
          condition: {
            variable: "Variável",
            operator: "Operador",
            value: "Valor",
          },
          start: {
            description:
              "O nó inicial é o ponto de entrada do fluxo. Não requer configuração adicional.",
          },
        },
        simulator: {
          title: "Pré-visualizar bot",
          restart: "Reiniciar",
          banner:
            "Simulação: nenhuma mensagem real é enviada e nenhum ticket é alterado.",
          canvasLocked: "A área de trabalho está bloqueada durante a pré-visualização",
          empty: "Clique em Pré-visualizar para percorrer o fluxo passo a passo.",
          running: "Percorrendo o fluxo…",
          hsmBadge: "Modelo WABA",
          chooseOption:
            "Selecione uma opção para continuar. Em conversas reais quem escolhe é o cliente.",
          typeReply: "Digite a resposta do cliente para continuar.",
          replyPlaceholder: "Resposta do cliente…",
          freeTextPlaceholder: "…ou digite qualquer resposta (ex.: 9)",
          noOptions:
            "Este nó não tem opções configuradas: o fluxo ficaria travado aqui.",
          connectionTitle: "Conexão",
          connectionHint:
            "Os avisos por canal dependem da conexão: há nós que nem todo provedor suporta.",
          connectionAuto: "Automática (primeira compatível)",
          contactTitle: "Contato simulado",
          // Sem chaves duplas de propósito: o i18next as trataria como interpolação.
          contactHint:
            "Alimenta as variáveis de nome, primeiro nome e número do contato e, com elas, o resultado dos nós de condição.",
          contactName: "Nome",
          contactNumber: "Número",
          executeHttp: "Executar de verdade as chamadas HTTP",
          executeAi: "Executar de verdade os nós de IA (consome tokens)",
          variablesTitle: "Variáveis do fluxo",
          status: {
            waiting: "Aguardando resposta",
            completed: "Fluxo concluído",
            error: "Erro",
            running: "Em execução",
          },
          errors: {
            generic: "Não foi possível executar a pré-visualização",
          },
        },
        validation: {
          noStartNode: "O fluxo deve ter pelo menos um nó inicial",
          nameRequired: "O nome do fluxo é obrigatório",
          panelTitle: "Validação do fluxo",
          allGood: "O fluxo não apresenta problemas",
          errorsLabel: "{{count}} erro(s)",
          warningsLabel: "{{count}} aviso(s)",
          blockedPreview: "Corrija os erros antes de pré-visualizar o fluxo",
          goToNode: "Ir para o nó",
          codes: {
            EMPTY_FLOW: "O fluxo não tem nós",
            NO_START_NODE: "O fluxo não tem nó inicial: nunca será executado",
            MULTIPLE_START_NODES:
              "Existem {{count}} nós iniciais. O motor usará apenas um e ignorará os demais",
            START_NO_EXIT:
              "O nó inicial não tem conexão de saída: o fluxo termina sem fazer nada",
            PAUSE_NODE_NO_EXIT:
              "«{{nodeLabel}}» aguarda resposta do usuário, mas não tem conexão de saída: o fluxo ficará travado",
            CONDITION_MISSING_BRANCH:
              "A condição «{{nodeLabel}}» não tem conectada(s) a(s) ramificação(ões): {{missing}}. Por esse caminho o fluxo termina em silêncio",
            BRANCH_NO_EXIT:
              "«{{nodeLabel}}» tem {{count}} saída(s) sem conectar ({{missing}}) e não há conexão padrão",
            BRANCH_USES_FALLBACK:
              "«{{nodeLabel}}» tem {{count}} saída(s) sem conectar ({{missing}}): usarão a conexão padrão",
            DEAD_END: "O fluxo termina em «{{nodeLabel}}»",
            ORPHAN_NODE:
              "«{{nodeLabel}}» não é alcançável a partir do nó inicial: nunca será executado",
            INFINITE_LOOP:
              "Laço sem ponto de espera ({{length}} nós): o motor para ao atingir {{maxIterations}} iterações e o fluxo termina em erro",
            EMPTY_TEXT: "«{{nodeLabel}}» não tem texto configurado",
            MISSING_MEDIA: "«{{nodeLabel}}» não tem arquivo carregado",
            MENU_NO_OPTIONS: "O menu «{{nodeLabel}}» não tem opções",
            BUTTONS_NO_BUTTONS: "«{{nodeLabel}}» não tem botões configurados",
            HSM_NO_TEMPLATE: "«{{nodeLabel}}» não tem modelo selecionado",
            HSM_NO_CONNECTION: "«{{nodeLabel}}» não tem conexão WABA selecionada",
            TAG_NO_TAG: "«{{nodeLabel}}» não tem etiqueta selecionada",
            TRANSFER_NO_QUEUE: "«{{nodeLabel}}» não tem setor de destino",
            SETVAR_NO_KEY:
              "«{{nodeLabel}}» não tem nome de variável configurado",
            HTTP_NO_URL: "«{{nodeLabel}}» não tem URL configurada",
            CONDITION_NO_VARIABLE:
              "«{{nodeLabel}}» não tem variável para avaliar",
            CONTENT_NO_ITEMS:
              "«{{nodeLabel}}» não tem elementos: não enviará nada",
            CONTENT_ITEMS_EMPTY:
              "«{{nodeLabel}}» tem {{count}} de {{total}} elemento(s) sem conteúdo: serão ignorados no envio",
            OPENAI_NO_PROMPT:
              "«{{nodeLabel}}» não tem Agente IA selecionado: usará a configuração herdada",
            TIMING_ZERO: "«{{nodeLabel}}» tem tempo 0: não fará nada",
            NODE_REQUIRES_WABA:
              "«{{nodeLabel}}» só funciona em fluxos do WhatsApp Cloud API (WABA)",
          },
        },
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
	reports: {
        title: "Relatórios de Atendimentos",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento"
        },
        buttons: {
          filter: "Aplicar Filtro",
        },
        searchPlaceholder: "Pesquisar...",
      },	  
      files: {
        title: "Lista de arquivos",
        adminTitle: "Administrador de arquivos",
        searchPlaceholder: "Buscar listas de arquivos...",
        newList: "Nova lista de arquivos",
        listCount: "{{count}} listas",
        table: {
          name: "Nome da lista",
          description: "Descrição",
          fileCount: "Quantidade de arquivos",
          createdAt: "Data de criação",
          actions: "Ações",
        },
        noDescription: "Sem descrição",
        filesInList: "{{count}} arquivos",
        tooltips: { editList: "Editar lista", deleteList: "Excluir lista" },
        contacts: "Contatos",
        actions: "Ação",
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      messagesAPI: {
        reference: {
          copy: "Copiar",
          copied: "Copiado para a área de transferência",
          request: "Exemplo de requisição",
          response: "Exemplo de resposta",
          curl: "Exemplo cURL",
          paramName: "Parâmetro",
          paramValue: "Valor / descrição",
          textBody: "Texto da mensagem",
          mediaFile: "Arquivo (imagem, vídeo, documento ou áudio)",
          optionalText: "Texto acompanhante (opcional)",
          groupId: "ID do grupo (o sistema adiciona @g.us)",
        },
        auth: {
          title: "Autenticação",
        },
        instance: {
          comingSoon: "Em breve",
          body: "Gerenciamento da conexão via API (apenas Baileys): consulte o status, obtenha o QR code e force a reconexão. O token Bearer identifica a conexão.",
          statusTitle: "Status da conexão",
          statusDesc: "Retorna o estado atual: conectado/desconectado, número vinculado, bateria e provedor.",
          qrTitle: "QR code",
          qrDesc: "Retorna a string QR (qrcode) e também a imagem pronta qrImage (data:image/png;base64) para exibir com <img> direto. Se vier vazia, force a geração com POST /reconnect e consulte novamente até aparecer.",
          qrNote: "Fluxo típico: POST /reconnect para gerar um QR novo → consulte GET /qr a cada poucos segundos até escanear → GET /status confirma CONNECTED.",
          qrViewTitle: "Página QR hospedada",
          qrViewDesc: "Página HTML pronta para usar que mostra o QR ao vivo, renova automaticamente e detecta a conexão. Abra no navegador ou incorpore em um iframe — ideal para clientes sem frontend (Excel, scripts). O token vai na URL.",
          qrViewNote: "Onboarding sem código: o usuário final escaneia e a página detecta CONNECTED sozinha. O token viaja na URL (usar em links de curta duração).",
          reconnectTitle: "Reconectar",
          reconnectDesc: "Reinicia a sessão e gera um QR novo se necessário (não apaga credenciais). Útil quando a conexão cai.",
          rebootTitle: "Reiniciar (reboot)",
          rebootDesc: "Encerra a sessão do WhatsApp Web (logout) e força um novo escaneamento. Limpa o estado, mas mantém a configuração da conexão.",
          rebootNote: "Ação destrutiva: desconecta o número atual. Você precisará escanear um novo QR para reconectar.",
          resetTitle: "Reset total",
          resetDesc: "Recomeço do zero: encerra a sessão, apaga as credenciais salvas e gera um novo QR.",
          resetNote: "Ação destrutiva e irreversível: apaga as credenciais da conexão. Use apenas para vincular outro número ou corrigir um estado corrompido.",
          webhookTitle: "Registrar webhook",
          webhookDesc: "Registra uma URL que receberá eventos da conexão (por enquanto: mudanças de status da conexão). Os eventos são enviados via POST como { event, instanceId, timestamp, data }.",
          webhookUrlParam: "URL https que receberá os eventos (POST)",
          webhookEnableParam: "true/false para ativar ou desativar (opcional; padrão true quando há url)",
          webhookNote: "São enviados eventos de status de conexão (event: connection.update); quando o status é qrcode, o payload inclui qrcode + qrImage (você recebe o QR por push, sem poll). Eventos de mensagens (entrada/saída) chegarão em versão posterior.",
        },
        nav: {
          auth: "Autenticação",
          instance: "Instância / Conexão",
          messages: "Mensageria",
          groups: "Grupos",
          external: "CRM / External",
          account: "Conta / Provisão",
        },
        account: {
          body: "Endpoints de nível CONTA para provisionar conexões. Usam a API Key de conta (não o token por conexão). A criação respeita o limite de conexões do seu plano.",
          keyTitle: "API Key de conta",
          keyLoading: "Carregando…",
          keyWarning: "Trate como uma senha. Ao regenerar, a anterior deixa de funcionar.",
          regenerate: "Regenerar API Key",
          regenerated: "API Key regenerada",
          regenerateError: "Não foi possível regenerar a API Key",
          createTitle: "Criar conexão",
          createDesc: "Cria uma nova conexão (instância) na conta e retorna seu token por conexão para operá-la. Respeita a cota de conexões do plano.",
          createNameParam: "Nome da conexão (obrigatório)",
          createProviderParam: "baileys (padrão) ou evolution (opcional)",
          createNote: "O token retornado é o token por conexão: use em /api/v1/instance/* e /api/messages/*. Se exceder o limite do plano, retorna erro de cota.",
          listTitle: "Listar conexões",
          listDesc: "Lista todas as conexões da conta com seu status e token por conexão.",
        },
        title: "API Pública",
        documentation: {
          title: "Documentação de envio de mensagens",
          methods: "Métodos de envio",
          instructions: "Instruções",
          importantNotes: "Observações importantes",
          textMessages: "Mensagens de texto",
          mediaMessages: "Mensagens multimídia",
          endpoint: "Endpoint",
          method: "Método",
          headers: "Headers",
          body: "Body",
          formData: "FormData",
          testSend: "Teste de envio",
          send: "Enviar",
        },
        instructions: {
          tokenRequired:
            "Antes de enviar mensagens, registre o token vinculado à conexão que enviará as mensagens. Acesse Conexões, edite a conexão e insira o token no campo correspondente.",
          numberFormat:
            "O número não deve ter máscara nem caracteres especiais e deve conter:",
          countryCode: "Código do país",
          areaCode: "DDD",
          number: "Número",
        },
        importantInfo: {
          title: "Informação importante",
          tokenLabel: "Token obrigatório",
          tokenBody:
            "Registre um token vinculado à conexão que enviará as mensagens",
          formatLabel: "Formato do número",
          formatBody: "Código do país + DDD + número (sem caracteres especiais)",
          exampleLabel: "Exemplo",
          exampleBody:
            "51959858768 (Peru: 51, DDD: 959, Número: 858768)",
        },
        chips: {
          endpoint: "ENDPOINT",
          method: "MÉTODO",
          headers: "HEADERS",
          upTo100mb: "ATÉ 100MB",
        },
        common: {
          apiInfoTitle: "Informação da API",
          testSendTitle: "Teste de envio",
          bodyJson: "Body (JSON):",
          formData: "FormData:",
        },
        section1: {
          title: "1. Mensagens de texto",
          intro:
            "Envie mensagens de texto simples pela API do WhatsApp Business.",
          bodySnippet: `{ "number": "51959858768", "body": "Sua mensagem" }`,
        },
        section2: {
          title: "2. Mensagens multimídia",
          intro:
            "Envie arquivos multimídia (imagens, vídeos, documentos, áudio) pela API do WhatsApp Business.",
          maxCapacity: "Capacidade máxima:",
          maxCapacityBody: "Arquivos de até 100 MB",
          formDataNumber: "number:",
          formDataNumberEx: "51959858768",
          formDataMedias: "medias:",
          formDataMediasEx: "arquivo",
          formDataBody: "body:",
          formDataBodyEx: "legenda opcional (texto de acompanhamento)",
          fileTypesTitle: "Tipos de arquivo suportados:",
          images: "Imagens:",
          imagesEx: "JPG, PNG, GIF (até 5MB)",
          videos: "Vídeos:",
          videosEx: "MP4, AVI, MOV (até 16MB)",
          documents: "Documentos:",
          documentsEx: "PDF, DOC, XLS, PPT (até 100MB)",
          audio: "Áudio:",
          audioEx: "MP3, WAV, OGG (até 16MB)",
        },
        section3: {
          title: "3. Mensagens para grupos do WhatsApp",
          intro: "Envie mensagens de texto para grupos do WhatsApp pela API.",
          bodySnippet: `{ "number": "12036312345678901234", "body": "Sua mensagem" }`,
          groupNote: "Nota:",
          groupNoteBody:
            "O sistema adicionará automaticamente o sufixo @g.us ao ID do grupo",
        },
        section4: {
          title: "4. Multimídia para grupos",
          intro:
            "Envie arquivos multimídia para grupos do WhatsApp pela API.",
          formDataNumberLi: "ID do grupo (ex.: 12036312345678901234)",
          formDataMediasLi: "arquivo multimídia",
        },
        forms: {
          tokenRegistered: "Token cadastrado",
          tokenRegisteredReq: "Token cadastrado *",
          tokenPlaceholder: "Digite seu token aqui",
          number: "Número",
          numberReq: "Número *",
          message: "Mensagem",
          messageReq: "Mensagem *",
          messageOptional: "Mensagem (opcional)",
          messageOptionalPlaceholder:
            "Legenda opcional para acompanhar o arquivo...",
          messagePlaceholder: "Digite sua mensagem aqui",
          numberPlaceholder: "51980795094",
          fileName: "Nome do arquivo",
          sendMessage: "ENVIAR MENSAGEM",
          sendMedia: "Enviar multimídia",
          selectFile: "Selecionar arquivo",
          clickUploadHint:
            "Clique para selecionar um arquivo multimídia",
          fileSize: "Tamanho:",
          groupId: "ID do grupo *",
          groupIdHelper:
            "ID do grupo sem @g.us (ex.: 12036312345678901234)",
          groupIdHelperShort: "ID do grupo sem @g.us",
          sendToGroup: "Enviar ao grupo",
          sendMediaToGroup: "Enviar multimídia ao grupo",
        },
        fileSize: {
          bytes: "Bytes",
          kb: "KB",
          mb: "MB",
          gb: "GB",
        },
        apiInfo: {
          textMessageInfo:
            "Abaixo as informações necessárias para envio de mensagens de texto:",
          mediaMessageInfo:
            "Abaixo as informações necessárias para envio de mensagens multimídia:",
          authorization:
            "Authorization (Bearer token) e Content-Type (application/json)",
          multipartForm:
            "Authorization (Bearer token) e Content-Type (multipart/form-data)",
          exampleBody: '{ "number": "51959858768", "body": "Sua mensagem" }',
          exampleNumber: "51959858768",
          exampleFile: "arquivo",
        },
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        section5: {
          d: {
            byNumber: "Consulta o status e os dados de um ticket pelo número do contato (país + DDD + número). Retorna o objeto variables com as informações do ticket.",
            byId: "Igual à consulta por número, mas usando o ID interno do ticket.",
            users: "Lista os usuários/agentes da empresa (id, nome, email). Útil para atribuir tickets a um agente.",
            tags: "Lista as etiquetas disponíveis (id, nome). Útil para saber qual tagId atribuir.",
            assignTag: "Atribui uma etiqueta a um ticket existente.",
            updateTicket: "Atualiza um ticket: muda o status, o agente atribuído e/ou a fila.",
            tagIdValue: "ID da etiqueta a atribuir (ver GET /tags)",
            statusValue: "Status do ticket: open, pending ou closed",
            userIdValue: "ID do agente a atribuir (ver GET /users)",
            queueIdValue: "ID da fila/departamento",
            typebotTitle: "Compatibilidade Typebot / N8N (alternativa POST)",
            typebotDesc: "Plataformas que só permitem POST (como o Typebot) podem consultar/criar o ticket enviando os dados por body ou query params. A resposta inclui o objeto variables pronto para mapear nas variáveis do seu fluxo.",
            typebotNumber: "Número do contato (ou use ?number={{telefono}} na URL)",
            typebotAtendimento: "Alternativamente, o ID do ticket (atendimento)",
            typebotNote: "No Typebot: no bloco HTTP Request use POST para /ticket?number={{telefono}}, cabeçalho Authorization: Bearer <TOKEN>, e salve a resposta em variáveis (data.variables.numero, nome, atendimento).",
            variablesDesc: "Todas as respostas de ticket incluem este objeto variables, pronto para mapear no seu fluxo:",
          },
          title: "5. API externa — N8N / TypeBot",
          intro:
            "Endpoints para integrações externas (N8N, TypeBot, etc.). Use o mesmo token do WhatsApp da API de mensagens. As respostas incluem o objeto variables compatível com TypeBot/N8N.",
          baseUrl: "URL base:",
          headersLine: "Headers:",
          getTicketByNumber: "GET — Ticket por número",
          getTicketById: "GET — Ticket por ID",
          getUsers: "GET — Usuários/agentes",
          getTags: "GET — Etiquetas",
          putAssignTag: "PUT — Atribuir etiqueta",
          putUpdateTicket: "PUT — Atualizar ticket",
          bodyLabel: "Body:",
          altPostTitle: "Alternativas POST (body ou query para Typebot):",
          postTicketBody1:
            'POST {{base}}/ticket — Body: { "atendimento": 1223 } ou { "number": "51980795334" }',
          postTicketBody2:
            "POST {{base}}/ticket?number={{telefono}} — variáveis na URL (Typebot)",
          postTicketBody3:
            "POST {{base}}/ticket/tag?atendimento={{atendimento}}&tagId=6 — query params",
          postTicketBody4:
            'POST {{base}}/ticket — Body: { "atendimento": 1223, "status": "open", "userId": 1 } (atualizar)',
          postUsersTags: "POST {{base}}/users — POST {{base}}/tags",
          variablesObjectTitle: "Objeto variables (respostas ticket):",
          variablesList:
            "atendimento, nome, numero, status, canal, grupo, user, userEmail, queue, tags, whatsappNumber, whatsappName",
          typebotGuideTitle: "Guia Typebot (fluxo validado):",
          typebotStep1:
            "Input: perguntar número, salvar na variável telefono",
          typebotStep2:
            "HTTP Request: POST /ticket?number={{telefono}} (use chaves para variável)",
          typebotStep3: "Headers: Authorization = Bearer token",
          typebotStep4:
            "Salvar em variables: data.variables.numero, nome, atendimento",
          typebotStep5: "Text: exibir numero, nome, atendimento",
          seeGuide: "Ver guia 0275 para detalhe completo.",
        },
        messages: {
          success: "Mensagem enviada com sucesso",
          successMedia: "Mensagem multimídia enviada com sucesso",
          successGroup: "Mensagem enviada ao grupo com sucesso",
          successGroupMedia:
            "Mensagem multimídia enviada ao grupo com sucesso",
          groupSendError: "Erro ao enviar mensagem ao grupo",
          groupMediaError: "Erro ao enviar multimídia ao grupo",
          noPermission:
            "Esta empresa não tem permissão para acessar esta página. Redirecionando…",
        },
        errors: {
          backendUrlNotConfigured: "REACT_APP_BACKEND_URL não está configurado",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        whatsappDisconnected: {
          title: "Sem conexões WhatsApp",
          body:
            "Não há conexões ativas. Configure ou reconecte suas conexões WhatsApp para continuar.",
          reconnect: "RECONECTAR AGORA",
          close: "Fechar",
        },
      },
      whatsappConnectionsMenu: {
        loadingConnections: "Carregando conexões…",
        tooltipNoConnections:
          "Sem conexões WhatsApp — clique para ver detalhes",
        tooltipSomeConnected:
          "Pelo menos uma conexão ativa — clique para ver a lista",
        tooltipNoneActive:
          "Nenhuma conexão ativa — clique para ver a lista",
        ariaLabel: "Status das conexões WhatsApp",
        menuTitle: "Conexões WhatsApp",
        loading: "Carregando…",
        noneConfigured: "Nenhuma conexão configurada",
        connectionFallback: "Conexão #{{id}}",
        manage: "Gerenciar conexões…",
        status: {
          connected: "Conectado",
          opening: "Conectando…",
          disconnected: "Desconectado",
        },
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        searchFieldPlaceholder: "Pesquisar respostas rápidas...",
        noAttachment: "Sem anexo",
        noFile: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          addReply: "Adicionar resposta",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Global",
          shortcodeHeader: "ATALHO",
          mediaNameHeader: "NOME DO ARQUIVO",
          statusHeader: "ESTADO",
          actionsHeader: "AÇÕES",
        },
        tooltips: {
          openAttachment: "Clique para abrir o arquivo",
          edit: "Editar resposta rápida",
          delete: "Excluir resposta rápida",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        tooltipContactVars: "Variáveis de contato",
        tooltipSystemVars: "Variáveis do sistema",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitle: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          aiAgent: "Agente IA",
          contactList: "Lista de Contatos",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Lista de Tags",
            fileList: "Lista de Arquivos",
          },
          ai: {
            wizardQuestion: "Deseja usar Inteligência Artificial dinâmica nas mensagens desta campanha?",
            wizardHelp:
              "Com IA, cada contato pode receber uma mensagem personalizada conforme o agente escolhido e o texto base (semente) que você digitar. Sem IA, o disparo segue como sempre. Com IA é obrigatório configurar etiquetas ante resposta.",
            choiceNo: "Não — modo clássico (Msg. 1–5 e anexos como antes)",
            choiceYes: "Sim — IA dinâmica (semente única + agente Prompt)",
            continue: "Continuar",
            modeLabel: "Modo de disparo em massa",
            modeClassic: "Clássico (sem IA no texto enviado)",
            modeAi: "IA dinâmica (mensagem única adaptada por contato)",
            promptAgent: "Agente IA (lista / legado)",
            promptAgentSend: "Agente IA (personaliza cada disparo)",
            replyPromptAgent: "Agente IA (quando o contato responder)",
            ariaAiEnvironment: "Campanha com assistente de inteligência artificial",
            promptPlaceholder: "Selecione um agente…",
            promptPlaceholderSend: "Selecione o agente para o disparo em massa…",
            promptPlaceholderReply: "Selecione o agente para ante resposta do contato…",
            seedBanner:
              "IA generativa ativa: serão criadas versões únicas da mensagem por destinatário; no servidor há variação aleatória nos intervalos de envio.",
            seedLabel: "Mensagem semente (base)",
            intervalHint: "Com IA dinâmica, o sistema aplica variação aleatória aos tempos de envio sobre os intervalos definidos aqui.",
            tagMandatoryHint: "Com IA dinâmica, a etiqueta ante resposta é obrigatória: ative e escolha qual aplicar.",
            autoTagForced: "Ativado (obrigatório com IA dinâmica)",
            responderTab: "RESPONDER",
            responderTitle: "Ante resposta do contato",
            responderBanner:
              "Escolha o agente a ser usado quando um contato responde após esta campanha. É independente do que personaliza cada mensagem enviada.",
            attachFileAria: "Anexar arquivo",
            errors: {
              promptSendRequired: "Selecione o agente IA para o disparo em massa.",
              replyPromptRequired: "Selecione o agente IA para ante resposta (aba RESPONDER)."
            },
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      announcements: {
        active: 'Ativo',
        inactive: 'Inativo',
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        toasts: {
          deleted: "Fila excluída com sucesso.",
        },
        table: {
          id: "ID",
          department: "Fila",
          name: "Nome",
          color: "Cor",
          automation: "Automação",
          greeting: "Mensagem de saudação",
          actions: "Ações",
          orderQueue: "Ordenação da fila (bot)",
        },
        automationLabels: {
          flowbuilder: "FLOWBUILDER",
          prompt: "PROMPT",
          integration: "INTEGRAÇÃO",
          chatbot: "CHATBOT",
          none: "Sem automação",
        },
        placeholders: {
          noGreeting: "Sem mensagem",
        },
        tooltips: {
          editQueue: "Editar fila",
          deleteQueue: "Excluir fila",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueOptions: {
        title: "Chatbot com menus de opções",
        subtitle:
          "Defina os botões que o contato verá no chat (menu em níveis). Não é um assistente de texto livre: o cliente navega tocando nas opções. Use «Adicionar» para cada item do menu.",
        add: "Adicionar",
        placeholder: {
          title: "Título da opção",
          message: "Texto da opção",
        },
        undefinedTitle: "Título não definido",
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      users: {
        title: "Usuários",
        table: {
		  id: "ID",
          name: "Nome",
		  status: "Status",
          email: "Email",
          profile: "Perfil",
          department: "Departamento",
          connection: "Conexão",
connectionFromTeam: "pela sua equipe",
                    connectionNone: "Sem conexão",
                    lastConnection: "Última conexão",
          lastConnectionNow: "Agora online",
          connected: "Conectada",
          disconnected: "Desconectada",
          actions: "Ações",
        },
		status: {
          online: "Usuários online",
          offline: "Usuários offline",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      helps: {
        title: "Central de Ajuda",
        form: {
          title: "Título",
          videoCode: "URL do vídeo (YouTube)",
          description: "Descrição",
        },
        table: {
          title: "Título",
          description: "Descrição",
          video: "Vídeo",
        },
        buttons: {
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
          saving: "A guardar...",
        },
        formTitle: {
          edit: "Editar vídeo de ajuda",
          create: "Criar novo vídeo de ajuda",
        },
        sectionVideo: "Informação do vídeo de ajuda",
        placeholders: {
          video: "https://youtu.be/6FdRJTw46qI ou https://seudominio.com/video.mp4",
          thumbnail: "https://seudominio.com/thumbnails/video.jpg",
        },
        helpers: {
          youtubeDetected: "✅ Vídeo do YouTube detetado",
          externalDetected: "✅ Vídeo externo detetado",
          pasteHint:
            "Cole o URL do YouTube ou um URL externo de vídeo (ex.: https://seudominio.com/video.mp4)",
        },
        thumbnail: {
          label: "URL da miniatura (opcional)",
          hint: "URL opcional da miniatura. Se vazio, usa miniatura do YouTube ou um marcador.",
        },
        grid: {
          emptyTitle: "Não há vídeos de ajuda registados",
          emptySubtitle: "Crie o seu primeiro vídeo de ajuda para começar",
        },
        tooltips: {
          editRow: "Editar vídeo de ajuda",
        },
        validation: {
          invalidVideoInput:
            "URL de vídeo inválida. Indique um URL do YouTube ou um URL externo válido (ex.: https://seudominio.com/video.mp4)",
          processFailed: "Não foi possível processar o URL do vídeo",
          urlInvalid: "URL inválida. Deve começar por http:// ou https://",
          urlExtensionHint:
            "O URL não tem extensão de vídeo. Certifique-se de que o servidor devolve o Content-Type correcto.",
        },
        toast: {
          youtubeDetected: "Vídeo do YouTube detetado: {{code}}",
          externalDetected: "Vídeo externo detetado e guardado",
        },
        messages: {
          loadError: "Não foi possível carregar os itens",
          saveSuccess: "Operação concluída com sucesso!",
          saveError:
            "Não foi possível salvar. Verifique duplicidade ou campos incompletos.",
          deleteSuccess: "Operação concluída com sucesso!",
          deleteError: "Não foi possível concluir a operação",
          deleteTitle: "Exclusão de registro",
          deleteMessage: "Deseja realmente excluir este registro?",
          videoUnavailable: "Vídeo indisponível",
          videoLoadError: "Não foi possível carregar o vídeo",
          videoLoadHint:
            "O vídeo pode estar indisponível ou a URL inacessível neste domínio.",
          videoCorsHint:
            "Verifique se o servidor permite acesso público (CORS) e se a URL está correta.",
          youtubeError: "Erro ao carregar vídeo do YouTube",
          videoUrlError:
            "Erro ao carregar vídeo. Verifique URL e formato.",
          videoNotSupported: "Seu navegador não suporta vídeo.",
        },
      },
      schedules: {
        title: "Agendamentos",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
		  deleteAllMessage: "Tem certeza que deseja deletar todas as Tags?",
		  deleteAllTitle: "Deletar Todos",
        },
        table: {
          name: "Nome",
          tagName: "Nome da etiqueta",
          color: "Cor",
          tickets: "Registros Tagdos",
          taggedTickets: "Tickets etiquetados",
          kanban: "Kanban",
          origin: "Origem",
          actions: "Ações",
        },
        kanbanActive: "ATIVO",
        kanbanInactive: "INATIVO",
        originProfile: "Por perfil",
        originManual: "Manual",
        readOnly: "Somente leitura",
        profileTagTitle: "Coluna Kanban criada com a Agenda ativa. Somente leitura.",
        manualTagTitle: "Etiqueta criada manualmente",
        readOnlyHint:
          "Colunas de perfil não são editadas aqui. Altere o perfil em Agenda > Configuração.",
        columnRenameTitle: "Renomear coluna",
        columnRenamePrompt: "Novo nome para esta coluna do quadro:",
        columnRenameHelper: "Muda apenas o texto visível; o quadro continua funcionando igual.",
        columnNameRequired: "O nome da coluna não pode ficar vazio.",
        columnSaved: "Coluna atualizada. Será mantida ao recriar o Kanban.",
        columnsReordered: "Ordem das colunas salva.",
        reorderNeedsNoFilter: "Limpe a busca para reordenar as colunas.",
        tooltips: {
          editTag: "Editar etiqueta",
          deleteTag: "Excluir etiqueta",
          renameColumn: "Renomear coluna do quadro",
          hideColumn: "Ocultar coluna do quadro",
          showColumn: "Mostrar coluna do quadro",
        },
        buttons: {
          add: "Nova Tag",
		  deleteAll: "Deletar Todas",
          cancel: "Cancelar",
          save: "Salvar",
        },
        toasts: {
		  deletedAll: "Todas Tags excluídas com sucesso!",
          deleted: "Tag excluído com sucesso.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        error: "Não foi possível guardar as configurações.",
        title: "Configurações",
        schedules: {
          success: "Horários guardados com sucesso.",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
        tabs: {
          options: "Opções",
          schedules: "Horários",
          version: "Versões",
          smtp: "SMTP",
          alerts: "Alertas",
          subscriptions: "Assinaturas",
          logo: "Web",
          companies: "Empresas",
          registerCompany: "Registrar empresa",
          plans: "Planos",
          help: "Ajuda",
          performance: "Desempenho do servidor",
        },
        options: {
          userRating: "Avaliação do usuário",
          userRatingDesc: "Permite que os usuários avaliem o atendimento",
          userRatingMessageText: "Mensagem de pedido de avaliação",
          userRatingMessageTextDesc:
            "Enviada ao fechar tíquete (junto ao texto da conexão WhatsApp se houver). Máx. 500 caracteres. Mesmas regras da mensagem de chamadas: não pode ficar vazia ao guardar.",
          userRatingMessageTextPlaceholder: "Escreva de 1 a 3 para avaliar…",
          sendGreetingAcceptedMessageText: "Texto de saudação ao aceitar (menu)",
          sendGreetingAcceptedMessageTextDesc:
            "Usado como saudação do menu de opções quando o departamento não tem mensagem própria. Mustache: {{name}}, {{firstName}}, etc.",
          sendGreetingAcceptedMessageTextPlaceholder: "Olá {{name}}! Obrigado por contactar…",
          transferTicketMessageText: "Mensagem ao transferir de departamento",
          transferTicketMessageTextDesc:
            "Só é enviada se «Enviar mensagem de transferência» estiver ativa. Variáveis: {{name}}, {{firstName}} e {queueName} ou {{queueName}} para o destino.",
          transferTicketMessageTextPlaceholder: "Olá {{name}}! Foi transferido…",
          greetingOneQueueMessageText: "Saudação com um só departamento",
          greetingOneQueueMessageTextDesc:
            "Substitui ou complementa a saudação da conexão quando há só uma fila e a opção está ativa. Mustache: {{name}}, {{firstName}}, etc.",
          greetingOneQueueMessageTextPlaceholder: "Olá {{name}}! Obrigado por escrever…",
          scheduleType: "Tipo de horário",
          ignoreGroupMessages: "Ignorar mensagens de grupo",
          acceptCall: "Aceitar chamadas",
          sendCallAutoMessage: "Enviar mensagem automática com chamadas desativadas",
          sendCallAutoMessageDesc: "Quando ativo, envia mensagem automática com chamadas desativadas",
          callAutoMessage: "Mensagem automática de chamadas",
          callAutoMessageDesc: "Personalize a mensagem enviada automaticamente com chamadas desativadas",
          callAutoMessagePlaceholder: "Escreva a mensagem automática (máx. 500 caracteres)",
          restoreDefault: "Restaurar predefinição",
          preview: "Pré-visualização",
          chatbotType: "Tipo de chatbot",
          sendGreetingAccepted: "Enviar saudação ao aceitar",
          sendGreetingAcceptedDesc: "Envia saudação automática ao aceitar tíquete",
          sendTransferMessage: "Enviar mensagem de transferência",
          sendTransferMessageDesc: "Envia mensagem ao transferir entre departamentos",
          teamsEnabled: "Trabalhar com subgrupos",
          teamsEnabledDesc: "Habilita as equipes de trabalho: a página Subgrupos aparece e cada supervisor também vê a fila da sua equipe. Com a opção desligada, cada usuário é configurado individualmente.",
          teamsEnabledSaved: "Modo de trabalho atualizado",
          teamsEnabledError: "Não foi possível alterar o modo de trabalho",
                    removeTagsOnCloseTicket: "Remover etiquetas ao fechar",
          removeTagsOnCloseTicketDesc:
            "Se ativo, ao fechar remove todas as etiquetas e pede confirmação antes de fechar",
          sendTicketCloseMessage: "Mensagem ao fechar tíquete",
          sendTicketCloseMessageDesc:
            "Envia WhatsApp ao cliente ao fechar (não para grupos). Use {nroticket} para o número do tíquete",
          ticketCloseMessageText: "Texto da mensagem ao fechar",
          ticketCloseMessageTextDesc:
            "Mesmas regras da mensagem automática de chamadas: texto obrigatório (máx. 500), editável com «Restaurar predefinição». {nroticket} = ID do tíquete.",
          ticketCloseMessageTextPlaceholder:
            "💬⚙️ *Tíquete:* {nroticket} foi fechado. O bot volta em *5 minutos*",
          sendGreetingOneQueue: "Enviar saudação com um departamento",
          sendGreetingOneQueueDesc: "Mostra saudação quando há só uma fila",
          globalSettings: "Configurações globais",
          registrationAllowed: "Registo permitido",
          registrationVisible: "Registo visível",
          trialTime: "Período de teste",
          mainSettings: "Configurações principais",
          messagingSettings: "Configurações de mensagens",
          customerMessageLocale: "Idioma das mensagens automáticas ao cliente (WhatsApp)",
          customerMessageLocaleDesc:
            "Idioma de saudações, transferências, modelos e textos automáticos no WhatsApp. Independente do idioma do painel.",
          scheduleTypeDesc: "Define o tipo de horário de atendimento",
          ignoreGroupMessagesDesc: "Ignora grupos do WhatsApp",
          chatbotTypeDesc: "Tipo de chatbot para respostas automáticas",
          internalSignature: "Assinaturas internas",
          internalSignatureDesc: "Mostra o nome do utilizador em cada mensagem (só interno)",
          validateWhatsAppNumbers: "Validar números WhatsApp",
          validateWhatsAppNumbersDesc:
            "Valida se os números estão no WhatsApp ao importar listas. Se desativado, processa todos sem validação.",
          timezoneForCampaigns: "Fuso horário para campanhas",
          timezoneForCampaignsDesc: "Selecione o fuso para campanhas em massa",
          timezone: "Fuso horário",
          callAutoMessageMaxLength: "A mensagem não pode exceder 500 caracteres",
          callAutoMessageSaveError: "Erro ao guardar a mensagem",
          characters: "caracteres",
          registrationAllowedDesc: "Permite registo de novos utilizadores",
          registrationVisibleDesc: "Mostra o formulário de registo publicamente",
          trialTimeDesc: "Dias de teste para novos utilizadores",
          day: "dia",
          days: "dias",
          additionalSettings: "Configurações adicionais",
          webInfo: "Info web",
          websiteTitle: "Título do site",
          websiteTitleDesc: "Título na aba do navegador e resultados de pesquisa",
          websiteDescription: "Descrição do site",
          websiteDescriptionDesc: "Descrição em pesquisa e redes sociais",
          websiteKeyword: "Palavra-chave do site",
          websiteKeywordDesc: "Principais palavras-chave para SEO",
          companyName: "Nome da empresa",
          companyNameDesc: "Nome no copyright do login",
          companyNameCopyright: "Nome da empresa (copyright)",
          logos: "Logos",
          exampleCliqueaCRM: "Exemplo: Cliquea CRM",
          exampleAutomatiza: "Exemplo: Automatize, conecte e venda mais!",
          exampleWhatsAppAPI: "Exemplo: WHATSAPP API",
          exampleWatoolx: "Exemplo: watoolx.com",
          localeEs: "Espanhol",
          localeEn: "English",
          localePt: "Português",
          loadingTimezones: "A carregar fusos horários…",
          timezoneQuickPeru: "Peru (America/Lima)",
          timezoneQuickColombia: "Colômbia (America/Bogota)",
          ariaSectionMain: "Configurações principais",
          ariaSectionMessaging: "Configurações de mensagens",
        },
        states: {
          disabled: "Desativado",
          enabled: "Ativado",
          activated: "Ativado",
          deactivated: "Desativado",
          accept: "Aceitar",
          notAccept: "Não aceitar",
          text: "Texto",
          updating: "A atualizar...",
          yes: "Sim",
          no: "Não",
          queue: "Departamento",
          company: "Empresa",
        },
        versionPage: {
          loading: "A carregar informação de versão…",
          title: "Informação de versão do sistema",
          ariaVersion: "Versão",
          currentVersion: "Versão atual",
          changelogChip: "changelog {{version}}",
          releaseDateChangelog: "Data de release (CHANGELOG):",
          changeType: "Tipo de alteração",
          milestoneTitle: "Marco arquitetural",
          milestoneDefault: "Evolução de monolito para arquitetura hexagonal modular e quitação total da dívida técnica. Base para Meta Cloud API e novos canais.",
          gitDateChip: "Data via Git",
          releaseSummary: "Resumo do último release",
          viewFullHistory: "Ver histórico completo →",
          changesCount: "{{count}} alterações",
          frontendVersion: "Versão front-end",
          apiVersion: "Versão API (pacote backend)",
          baseWhaticket: "Base Whaticket:",
          lastUpdate: "Última atualização",
          semanticFooter: "Versionamento semântico ativo",
          fullHistory: "Ver histórico completo →",
          na: "N/D",
        },
        subscriptionsPayment: {
          title: "Métodos de pagamento",
          intro:
            "Configure credenciais PayPal e Stripe para pagamentos recorrentes. ",
          introNote:
            "Nota: após guardar, reinicie o servidor backend para aplicar.",
          saving: "A guardar…",
          sectionPaypal: "PayPal",
          sectionStripe: "Stripe",
          sectionCurrency: "Moeda",
          paypalClientIdLabel: "ID de cliente PayPal",
          paypalClientIdDesc: "ID de cliente da aplicação PayPal",
          paypalClientIdField: "PayPal Client ID",
          paypalClientIdHelper:
            "Exemplo: AQkquBDf1zctJOWLbrloE4zQnlX4rQvBfhXUZHX96zShVqSB2ikbkGg",
          paypalSecretLabel: "Segredo do cliente PayPal",
          paypalSecretDesc: "Segredo da aplicação PayPal",
          paypalSecretField: "PayPal Client Secret",
          paypalSecretHelper: "Segredo da sua aplicação PayPal",
          paypalModeLabel: "Modo PayPal",
          paypalModeDesc: "Sandbox (testes) ou live (produção)",
          modeField: "Modo",
          modeSandbox: "Sandbox (testes)",
          modeLive: "Live (produção)",
          stripeKeyLabel: "Chave secreta Stripe",
          stripeKeyDesc: "Chave secreta da conta Stripe (sk_test_… ou sk_live_…)",
          stripeKeyField: "Stripe Secret Key",
          stripeKeyHelper: "Exemplo: sk_test_51AbCdEf…",
          stripeWebhookLabel: "Webhook secret Stripe",
          stripeWebhookDesc: "Segredo do webhook para verificar eventos (whsec_…)",
          stripeWebhookField: "Stripe Webhook Secret",
          stripeWebhookHelper: "Exemplo: whsec_1234567890abcdef",
          currencyLabel: "Moeda preferida",
          currencyDesc: "Moeda em planos e faturas",
          currencyField: "Moeda",
          currencyUSD: "USD — Dólar ($)",
          currencyEUR: "EUR — Euro (€)",
          currencyGBP: "GBP — Libra (£)",
          currencyBRL: "BRL — Real (R$)",
          currencyMXN: "MXN — Peso mexicano ($)",
          currencyARS: "ARS — Peso argentino ($)",
          currencyCLP: "CLP — Peso chileno ($)",
          currencyCOP: "COP — Peso colombiano ($)",
          currencyPEN: "PEN — Sol peruano (S/)",
          toastPaypalId: "PayPal Client ID guardado",
          toastPaypalSecret: "PayPal Client Secret guardado",
          toastPaypalMode: "Modo PayPal atualizado",
          toastStripeKey: "Stripe Secret Key guardado",
          toastStripeWebhook: "Stripe Webhook Secret guardado",
          toastCurrency: "Moeda atualizada",
        },
        smtpManager: {
          pageTitle: "SMTP e modelos",
          tabSmtp: "Configurações SMTP",
          tabTemplates: "Modelos de email",
          sectionTitle: "Configurações SMTP",
          newConfig: "Nova configuração",
          emptyList: "Sem configurações SMTP. Crie uma para começar.",
          colName: "Nome",
          colProvider: "Fornecedor",
          colHost: "Host",
          colPort: "Porta",
          colUser: "Utilizador",
          colStatus: "Estado",
          colActions: "Ações",
          defaultChip: "Predefinido",
          statusActive: "Ativo",
          statusInactive: "Inativo",
          tooltipTest: "Testar ligação",
          tooltipEdit: "Editar",
          tooltipDelete: "Eliminar",
          dialogNew: "Nova configuração SMTP",
          dialogEdit: "Editar configuração SMTP",
          fieldName: "Nome",
          fieldProvider: "Fornecedor",
          providerCustom: "Personalizado",
          fieldDescription: "Descrição",
          fieldHost: "Host SMTP",
          fieldPort: "Porta",
          fieldUser: "Utilizador / email",
          fieldPassword: "Palavra-passe",
          passwordKeepHint: "Vazio para manter a atual",
          gmailTooltipTitle: "Informação Gmail",
          gmailTooltipBody:
            "No Gmail use palavra-passe de aplicação, não a palavra-passe normal.",
          gmailTooltipSteps: "Passos:",
          gmailTooltipStep1: "1. Google → Segurança",
          gmailTooltipStep2: "2. Ative verificação em duas etapas",
          gmailTooltipStep3: "3. «Palavras-passe de aplicações»",
          gmailTooltipStep4: "4. Gerar para «Correio»",
          gmailTooltipStep5: "5. Use a palavra-passe de 16 caracteres aqui",
          gmailGuideLink: "Guia completo",
          fieldFrom: "Remetente (From)",
          sslLabel: "SSL (porta 465)",
          tlsLabel: "Exigir TLS (porta 587)",
          activeLabel: "Ativa",
          defaultLabel: "Predefinida",
          cancel: "Cancelar",
          save: "Guardar",
          testDialogTitle: "Testar ligação SMTP",
          testSuccess: "Ligação OK",
          testError: "Erro de ligação",
          deleteConfirm: "Eliminar esta configuração?",
          providerGmail: "Gmail",
          providerOutlook: "Outlook",
          fieldFromPlaceholder: "Nome <email@dominio.com>",
          testTitleSuccess: "Teste de ligação bem-sucedido",
          testTitleFail: "Falha no teste de ligação",
          testTitlePending: "A testar ligação SMTP…",
          testVerifying: "A verificar ligação ao servidor SMTP…",
          alertOkTitle: "Ligação OK",
          alertOkBody: "A configuração SMTP ligou-se ao servidor com sucesso.",
          alertErrTitle: "Erro de ligação",
          alertErrBody: "Não foi possível ligar ao servidor SMTP.",
          errorDetailsLabel: "Detalhes do erro:",
          close: "Fechar",
          suggestedFixTitle: "Sugestão:",
          suggestedFixBody:
            "Se usar Gmail, utilize palavra-passe de aplicação em vez da palavra-passe normal.",
        },
        vpsAlerts: {
          validation: {
            smtpSelect:
              "SMTP: escolha uma conta em «Configuração SMTP *» (não deixe «Seleccionar SMTP…»).",
            adminEmailRequired:
              "Email do administrador: obrigatório quando usa correio.",
            adminEmailInvalid: "Email do administrador: formato inválido.",
            whatsappSelect:
              "WhatsApp: escolha uma linha em «Ligação WhatsApp *» (vazio impede guardar).",
            adminWhatsappRequired:
              "Número WhatsApp do administrador: obrigatório quando usa WhatsApp.",
            adminWhatsappInvalid:
              "Número WhatsApp: use 10 a 15 dígitos; pode prefixar +.",
            whatsappTemplateRequired:
              "Modelo de mensagem WhatsApp: não pode estar vazio.",
          },
          validationModal: {
            bodyIntro: "O pedido não foi enviado. Complete o seguinte:",
            titleTest: "Faltam dados para o teste",
            titleSave: "Não é possível guardar: formulário incompleto",
          },
          notes: {
            noActiveSmtpTest:
              "Nota: não há contas SMTP activas. Configure uma no separador «SMTP».",
            noActiveSmtpSave:
              "Nota: não há contas SMTP activas. Crie ou active uma no separador «SMTP».",
            noConnectedWhatsapp:
              "Nota: não há WhatsApp em estado LIGADO; veja «Conexões».",
          },
          test: {
            lineEmailOk: "✅ Email enviado com sucesso",
            lineWhatsappOk: "✅ WhatsApp enviado com sucesso",
            successIntro: "Notificação de teste enviada com sucesso:",
            footerEmail: "Verifique o email para confirmar a recepção.",
            footerWhatsapp: "Verifique o WhatsApp para confirmar a recepção.",
            footerBoth: "Verifique o email e o WhatsApp para confirmar a recepção.",
            errorIntro: "Erro ao enviar notificação de teste:",
            unknownError: "Erro desconhecido",
          },
          save: {
            notSavedTitle: "A configuração não foi guardada",
            notSavedBody:
              "Veja a mensagem de erro no ecrã (se existir) e a sua ligação. Se persistir, tente novamente.",
            successTitle: "✅ Configuração guardada",
            successBody: "A configuração de notificações VPS foi guardada com sucesso.",
            errorTitle: "❌ Erro ao guardar",
            errorBody: "Erro ao guardar a configuração: {{message}}",
          },
          loadError:
            "Não foi possível carregar a configuração de alertas VPS: {{error}}. Confirme que o utilizador é administrador, a API está disponível e existem os objectos de BD (VPSNotificationConfig, SP).",
          retry: "Tentar novamente",
          generalSection: "Habilitação geral",
          toggleLabel: "Activar sistema de alertas e limpeza automática",
          infoWhyTitle: "Porquê activar este sistema?",
          infoIntro:
            "Este sistema de alertas e limpeza automática é especialmente útil se:",
          infoLi1: "O seu negócio gere milhares de mensagens WhatsApp por dia",
          infoLi2: "Gera muitos registos na base de dados",
          infoLi3: "Precisa de monitorização proactiva do servidor",
          infoLi4: "Quer prevenir discos cheios",
          infoClosing:
            "Se o negócio é pequeno e gera poucos registos, pode manter o sistema desactivado.",
          warningEnabled:
            "IMPORTANTE: Uma vez activo, receberá alertas automáticos quando o sistema detetar problemas. Configure correctamente email ou WhatsApp.",
          notificationsSection: "Configuração de notificações",
          channelEmail: "Email",
          channelWhatsapp: "WhatsApp",
          channelBoth: "Ambos",
          emailSection: "Configuração de email",
          smtpRequiredLabel: "Configuração SMTP *",
          selectSmtp: "Seleccionar SMTP...",
          emailTemplateOptional: "Modelo de email (opcional)",
          useDefaultTemplates: "Usar modelos por defeito",
          adminEmailLabel: "Email do administrador *",
          invalidEmail: "Formato de email inválido",
          adminEmailHint: "Email onde receberá os alertas",
          whatsappSection: "Configuração WhatsApp",
          whatsappConnectionLabel: "Ligação WhatsApp *",
          selectWhatsapp: "Seleccionar WhatsApp...",
          whatsappTemplateLabel: "Modelo de mensagem WhatsApp",
          whatsappTemplateVars:
            "Variáveis: {alertType}, {diskUsage}, {binaryLogsSize}, {cpuUsage}, {memoryUsage}, {message}, {subject}",
          adminWhatsappLabel: "Número WhatsApp do administrador *",
          invalidWhatsapp:
            "Formato inválido (10-15 dígitos, opcionalmente com +)",
          adminWhatsappHint: "Número onde receberá os alertas (com indicativo)",
          thresholdsSection: "Umbrais de alertas",
          diskPct: "Disco (%)",
          diskHelp: "Alerta quando o uso do disco ultrapassar esta percentagem",
          binaryGb: "Binary logs (GB)",
          binaryHelp: "Alerta quando o tamanho dos binary logs ultrapassar este valor",
          cpuPct: "CPU (%)",
          cpuHelp: "Alerta quando o uso de CPU ultrapassar esta percentagem",
          memPct: "Memória (%)",
          memHelp: "Alerta quando o uso de memória ultrapassar esta percentagem",
          enableDisk: "Activar alertas de disco",
          enableBinary: "Activar alertas de binary logs",
          enableCpu: "Activar alertas de CPU",
          enableMem: "Activar alertas de memória",
          enableCritical: "Activar alertas críticas",
          frequencySection: "Frequência de notificações e limpeza automática",
          alertFreqLabel: "Frequência de alertas (horas)",
          alertFreqHelp: "De quantas em quantas horas são enviados alertas (1-48)",
          cleanupSubtitle: "Limpeza automática do servidor",
          cleanupInfoTitle: "O que faz esta secção",
          cleanupInfoIntro:
            "Com a limpeza activa, o sistema pode executar manutenção sem intervenção manual:",
          cleanupInfoLi1:
            "Se o disco ultrapassar o limite (%): rotina completa (purga de binary logs conforme política do servidor, passos iterativos, optimização de tabelas críticas).",
          cleanupInfoLi2:
            "Se o disco estiver abaixo do limite mas os binary logs MySQL ultrapassarem o limite (GB): purga progressiva de logs.",
          cleanupRisk:
            "Risco operacional: a purga de binary logs afecta recuperação point-in-time (PITR). Use limites alinhados com backups e réplicas MySQL.",
          enableAutoCleanup: "Activar limpeza automática",
          cleanupCooldownNote:
            "A frequência de alertas ({{hours}} h) também limita repetições da limpeza disparada só por binary logs (GB) (cooldown desde a última execução desse tipo).",
          cleanupDiskThreshold: "Limite de disco para limpeza (%)",
          cleanupDiskHelp:
            "Se o uso do disco atingir este %, corre a rotina completa de limpeza (binlogs + passos adicionais conforme BD).",
          cleanupBinlogGb: "Limite de binary logs para limpeza (GB)",
          cleanupBinlogHelp:
            "Se o tamanho estimado de binary logs ≥ este valor e o disco não disparou a rotina anterior, purga progressiva. Normalmente menor que o limite só de alerta (GB).",
          lastCleanup:
            "Última limpeza automática (limite binary logs): {{date}}",
          saveConfig: "Guardar configuração",
          saving: "A guardar...",
          sendTest: "Enviar notificação de teste",
          sending: "A enviar...",
          testModal: {
            sending: "A enviar notificação de teste...",
            success: "✅ Notificação enviada",
            error: "❌ Erro ao enviar",
            pleaseWait: "Aguarde enquanto a notificação é enviada...",
            tipPrefix: "Dica:",
            tipEmail: "Verifique o email para confirmar a recepção.",
            tipWhatsapp: "Verifique o WhatsApp para confirmar a recepção.",
            tipBoth: "Verifique o email e o WhatsApp para confirmar a recepção.",
            close: "Fechar",
            cancel: "Cancelar",
          },
          accept: "Aceitar",
          defaultWhatsAppTemplate:
            "⚠️ ALERTA VPS: {alertType}\n📊 Estado do sistema:\n💾 Disco: {diskUsage}%\n📝 Binary logs: {binaryLogsSize} GB\n⚡ CPU: {cpuUsage}%\n🧠 Memória: {memoryUsage}%\n\n{message}",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        mediaCaptionPlaceholder:
          "Adicione uma mensagem… (opcional — enviada com o arquivo)",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        dragDrop: {
          sectionTitle: "Lista de arquivos",
          main: "Arraste e solte seus arquivos aqui",
          sub: "ou clique para selecionar arquivos",
          formats:
            "Formatos suportados: PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, PNG, MP4, MP3",
        },
        table: {
          thumbnail: "Miniatura",
          name: "Nome",
          format: "Formato",
          size: "Peso",
          type: "Tipo",
          actions: "Ações",
        },
        validation: {
          nameMin: "Nome muito curto",
          required: "Obrigatório",
        },
        fileSize: { bytes: "Bytes", kb: "KB", mb: "MB", gb: "GB" },
        tooltips: { removeFile: "Excluir arquivo" },
        success: "Lista de arquivos salva com sucesso!",
      },
      financial: {
        title: "Financeiro",
        pageTitle: "Financeiro e assinaturas",
        tabs: {
          subscriptions: "Assinaturas",
          invoices: "Faturas",
          management: "Gestão",
        },
        table: {
          id: "ID",
          details: "Detalhes",
          value: "Valor",
          dueDate: "Vencimento",
          status: "Status",
          action: "Ação",
        },
        status: {
          paid: "Pago",
          overdue: "Vencido",
          open: "Em aberto",
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGO",
        },
        messages: {
          noInvoices: "Não há faturas para exibir",
          paymentSuccess: "Pagamento processado com sucesso",
          paymentError: "Erro ao processar o pagamento",
        },
        subscription: {
          currentPlanLabel: "Plano atual",
          noPlanAssigned: "Nenhum plano atribuído",
          availablePlans: "Planos disponíveis",
          availablePlansHint:
            "Escolha um plano para assinar. Você pode pagar com PayPal ou Stripe.",
          perMonth: "/mês",
          users_one: "{{count}} usuário",
          users_other: "{{count}} usuários",
          connections_one: "{{count}} conexão WhatsApp",
          connections_other: "{{count}} conexões WhatsApp",
          queues_one: "{{count}} fila",
          queues_other: "{{count}} filas",
          featureCampaigns: "Campanhas",
          featureSchedules: "Agendamentos",
          featureOpenAi: "Inteligência artificial",
          subscribe: "Assinar",
          processing: "Processando…",
          noPlansTitle: "Nenhum plano disponível",
          noPlansHint: "Fale com o administrador para mais informações",
        },
      },
      kanban: {
        open: "Em aberto",
        tagNotFound: "Etiqueta não encontrada.",
        cannotMapStatus: "Não é possível mapear a coluna ao status da consulta.",
        theContact: "o contato",
        confirmMoveConfirmed: "Você vai confirmar o agendamento de {{name}} e será enviado um WhatsApp avisando.",
        confirmMoveCompleted: "Você vai concluir o agendamento de {{name}} e será enviada a mensagem de acompanhamento.",
        confirmMoveCancelled: "Você vai cancelar o agendamento de {{name}} e será enviado um WhatsApp avisando.",
        confirmMoveTitle: "Confirmar movimento",
        columnsReordered: "Ordem das colunas salva.",
        dragColumnHint: "Arraste o cabeçalho para reordenar esta coluna",
        confirmMoveIrreversible: "A mensagem não pode ser desfeita. Continuar?",
        moveNotAllowed: "Esse movimento não é permitido para o status atual do agendamento.",
        unassignedOwner: "Sem responsável",
        attendedByAI: "Atendido por {{name}}",
        appointmentUpdated: "Consulta atualizada.",
        ticketMoved: "Ticket movido com sucesso.",
        moveError: "Erro ao mover o card.",
        configureAgendaHint:
          "Configure a Agenda nas configurações para ver o Kanban por perfil.",
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        openInNewWindow: "Abrir conversa em nova aba",
        openInNewUnavailable: "Este tíquete não tem UUID; não é possível abrir em outra aba.",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        appointmentsModal: {
          title: "Observações do Contato",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket",
		  titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
		edit: 'Editar Mensagem',
		forward: "Encaminhar",
        toForward: "Encaminhar",
		react: "Reagir",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_TRANSFER_SIN_DESTINO: "Escolha um departamento ou uma pessoa: o ticket não pode ficar sem destino.",
        ERR_TRANSFER_FUERA_DE_EQUIPO: "Essa pessoa é de outra equipe. Você pode encaminhar o ticket ao departamento dela, ou pedir ao seu supervisor que o mova.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_DUP_NAME: "Esse nome já está sendo utilizado por outra conexão.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_QUEUE_NAME_ALREADY_EXISTS:
          "Este nome de departamento já existe, escolha outro.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_INTERNAL_SERVER: "Erro interno do servidor. Tente novamente ou contacte o suporte.",
        ERR_DB_VALIDATION: "Os dados não passaram na validação do banco de dados.",
        ERR_TICKET_UPDATE_FAILED: "Não foi possível atualizar o tíquete. Tente novamente.",
        ERR_SETTING_FOREIGN_COMPANY: "Não é possível alterar as configurações de outra empresa.",
        ERR_NO_WBOT_FOR_WHATSAPP:
          "Não há sessão WhatsApp ativa para a conexão {{whatsappId}}. Verifique a página de conexões.",
        ERR_UNKNOWN: "Ocorreu um erro inesperado.",
      },
      presence: {
        composing: "Digitando...",
        recording: "Gravando áudio...",
      },
      languages: {
        "pt-BR": "Português",
        en: "English",
        es: "Español",
      },

      hardcodedElements: {
        atendimento: "ATENDIMENTOS",
        tarefas: "TAREFAS",
        gerencia: "GERÊNCIA",
        campanhas: "CAMPANHAS",
        listagem: "LISTAGEM",
        configuracoes: "CONFIGURAÇÕES",
        administracao: "ADMINISTRAÇÃO",
        semFila: "SEM FILA",
        sair: "SAIR",
        sayHelloToNewContact: "Olá! Como posso ajudá-lo?",
        admin: "ADMIN",
        filas: "FILAS",
        todos: "TODOS",
        hey: "hey",
      },
    },
  },
};

export { messages };
